import { useState, useEffect, useRef } from "react";
import { supabase } from '../supabase';
import * as pdfjsLib from 'pdfjs-dist';
pdfjsLib.GlobalWorkerOptions.workerSrc = new URL("pdfjs-dist/build/pdf.worker.min.mjs", import.meta.url).toString();
const LOGO_B64 = "data:image/jpeg;base64,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";


// ── SAMPLE DATA ──────────────────────────────────────────────────────────────
const ALL_SYSTEMS = [
  { id: "sonos",    name: "Sonos" },
  { id: "lutron",   name: "Lutron App" },
  { id: "joshai",   name: "Josh AI" },
  { id: "icpro",    name: "ICView+" },
  { id: "alarm",    name: "Alarm.com" },
  { id: "unifi",    name: "UniFi Access" },
  { id: "samsung",  name: "Samsung Account" },
  { id: "denon",    name: "Denon HEOS" },
  { id: "doorbird", name: "DoorBird" },
];

const SAMPLE_CLIENTS = [
  {
    id: 1,
    inviteStatus: "active",
    name: "Marcus & Sarah Whitfield",
    address: "4820 Holladay Blvd, Holladay, UT",
    phone: "801-555-0192",
    email: "mwhitfield@email.com",
    installDate: "2026-03-15",
    systems: ["sonos","lutron","joshai","icpro","alarm"],
    credentials: { sonos: null, lutron: { email:"swhitfield@gmail.com", password:"••••••••", notes:"" }, joshai: null, icpro: null, alarm: { email:"swhitfield@gmail.com", password:"••••••••", notes:"2FA to 801-555-0192" } },
    serviceRequests: [
      { id: 1, subject: "Sonos zone 3 not responding", system: "Sonos", priority: "High", date: "2026-03-02", resolved: false, message: "The speakers in the home theater have stopped showing up in the Sonos app. Everything else works fine. We have guests coming this weekend — hoping to get this sorted soon.", internalNote: "" },
    ],
    notes: "Prefers morning calls. Has a dog — ring bell before entry.",
    portalLink: "https://smarttechutah.com/portal/whitfield-2024",
  },
  {
    id: 2,
    inviteStatus: "sent",
    name: "Derek & Tanya Ohlsen",
    address: "1140 Federal Heights Dr, Salt Lake City, UT",
    phone: "801-555-0344",
    email: "dohlsen@email.com",
    installDate: "2026-04-02",
    systems: ["sonos","lutron","joshai","samsung"],
    credentials: { sonos: null, lutron: null, joshai: null, samsung: null },
    serviceRequests: [],
    notes: "",
    portalLink: "https://smarttechutah.com/portal/ohlsen-2024",
  },
  {
    id: 3,
    inviteStatus: "not-sent",
    name: "Raymond Castellano",
    address: "892 Tomahawk Dr, Park City, UT",
    phone: "435-555-0811",
    email: "rcastellano@castellanogroup.com",
    installDate: "2026-02-10",
    systems: ["sonos","lutron","joshai","icpro","alarm","unifi"],
    credentials: { sonos: { email:"rcastellano@gmail.com", password:"••••••••", notes:"" }, lutron: { email:"rcastellano@gmail.com", password:"••••••••", notes:"" }, joshai: { email:"rcastellano@gmail.com", password:"••••••••", notes:"" }, icpro: { email:"rcastellano@gmail.com", password:"••••••••", notes:"" }, alarm: { email:"rcastellano@gmail.com", password:"••••••••", notes:"" }, unifi: { email:"rcastellano@gmail.com", password:"••••••••", notes:"" } },
    serviceRequests: [
      { id: 2, subject: "Add camera to rear gate", system: "ICView+", priority: "Normal", date: "2026-03-01", resolved: true, message: "We'd like to add a camera covering the rear gate entrance to the property. Can someone come out to assess and quote?", internalNote: "Quoted and scheduled for install March 20." },
    ],
    notes: "Full install complete. VIP client — direct Chad's cell for any issues.",
    portalLink: "https://smarttechutah.com/portal/castellano-2024",
  },
];

const EMPTY_CLIENT = {
  name: "", systemName: "", address: "", phone: "", email: "",
  installDate: "", systems: [], credentials: {},
  serviceRequests: [], notes: "", portalLink: "",
};

// ── ICONS ────────────────────────────────────────────────────────────────────
const Icon = ({ path, size = 16, stroke = "currentColor", fill = "none", strokeWidth = 1.5 }) => (
  <svg viewBox="0 0 24 24" fill={fill} stroke={stroke} strokeWidth={strokeWidth} width={size} height={size} strokeLinecap="round" strokeLinejoin="round">
    {typeof path === "string" ? <path d={path}/> : path}
  </svg>
);

const icons = {
  clients:   "M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2M9 7a4 4 0 100 8 4 4 0 000-8zM23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75",
  requests:  "M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z",
  creds:     "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z",
  plus:      "M12 5v14M5 12h14",
  copy:      "M8 4H6a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2v-1M8 4a2 2 0 012-2h4a2 2 0 012 2v1H8V4zM16 4h2a2 2 0 012 2v5",
  check:     "M20 6L9 17l-5-5",
  chevron:   "M9 18l6-6-6-6",
  back:      "M19 12H5M12 5l-7 7 7 7",
  edit:      "M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z",
  lock:      <><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0110 0v4"/></>,
  eye:       <><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></>,
  eyeOff:    <><path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19m-6.72-1.07a3 3 0 11-4.24-4.24M1 1l22 22"/></>,
  note:      "M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8zM14 2v6h6M16 13H8M16 17H8M10 9H8",
  resolve:   "M22 11.08V12a10 10 0 11-5.93-9.14M22 4L12 14.01l-3-3",
  close:     "M18 6L6 18M6 6l12 12",
  devices:   "M5 3h14a2 2 0 012 2v14a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2zM9 3v18M15 9h.01M15 13h.01M15 17h.01",
  key:       "M21 2l-2 2m-7.61 7.61a5.5 5.5 0 11-7.778 7.778 5.5 5.5 0 017.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4",
};

// ── STYLES ───────────────────────────────────────────────────────────────────
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@300;400;600&family=Montserrat:wght@400;500;600;700&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

  .id-root {
    padding-top: env(safe-area-inset-top);
    padding-bottom: env(safe-area-inset-bottom);
    min-height: 100vh;
    background: #F8F5F2;
    color: #111111;
    font-family: 'Montserrat', sans-serif;
    display: flex;
    flex-direction: column;
  }

  /* NAV */
  .id-nav {
    padding-top: env(safe-area-inset-top);
    height: 58px;
    background: #F8F5F2;
    border-bottom: 1px solid #DDD9D4;
    display: flex;
    align-items: center;
    padding: 0 28px;
    gap: 16px;
    position: sticky;
    top: 0;
    z-index: 100;
  }
  .id-nav-logo {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .id-nav-wordmark {
    display: flex;
    flex-direction: column;
    line-height: 1;
  }
  .id-nav-wordmark-top {
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.18em;
    color: #111111;
  }
  .id-nav-wordmark-divider {
    display: flex;
    align-items: center;
    gap: 5px;
    margin: 2px 0;
  }
  .id-nav-wordmark-line {
    height: 1px;
    width: 18px;
    background: #E50000;
  }
  .id-nav-wordmark-sub {
    font-size: 7px;
    font-weight: 600;
    letter-spacing: 0.22em;
    color: #777770;
  }
  .id-nav-badge {
    margin-left: auto;
    font-size: 9px;
    font-weight: 700;
    letter-spacing: 0.18em;
    text-transform: uppercase;
    color: #E50000;
    background: rgba(229,0,0,0.08);
    border: 1px solid rgba(229,0,0,0.2);
    border-radius: 2px;
    padding: 4px 10px;
  }

  /* LAYOUT */
  .id-body {
    display: flex;
    flex: 1;
    overflow: hidden;
    height: calc(100vh - 58px);
  }

  /* SIDEBAR */
  .id-sidebar {
    width: 220px;
    background: #F8F5F2;
    border-right: 1px solid #DDD9D4;
    padding: 24px 0;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    gap: 2px;
  }
  .id-sidebar-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 11px 20px;
    cursor: pointer;
    transition: all 0.15s;
    border-left: 2px solid transparent;
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: #888880;
    background: none;
    border-top: none;
    border-right: none;
    border-bottom: none;
    width: 100%;
    text-align: left;
    font-family: 'Montserrat', sans-serif;
  }
  .id-sidebar-item:hover { color: #555550; background: rgba(0,0,0,0.03); }
  .id-sidebar-item.active { color: #111111; border-left-color: #E50000; background: rgba(229,0,0,0.04); }
  .id-sidebar-badge {
    margin-left: auto;
    background: #E50000;
    color: #fff;
    font-size: 9px;
    font-weight: 700;
    border-radius: 10px;
    padding: 1px 6px;
    min-width: 18px;
    text-align: center;
  }

  /* MAIN */
  .id-main {
    flex: 1;
    overflow-y: auto;
    padding: 32px;
  }

  /* PAGE HEADER */
  .id-page-header {
    margin-bottom: 28px;
  }
  .id-page-eyebrow {
    font-size: 9px;
    font-weight: 700;
    letter-spacing: 0.22em;
    text-transform: uppercase;
    color: #E50000;
    margin-bottom: 6px;
  }
  .id-page-title {
    font-family: 'Cormorant Garamond', serif;
    font-size: 34px;
    font-weight: 300;
    color: #111111;
    letter-spacing: 0.01em;
  }

  /* STATS */
  .id-stats {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 14px;
    margin-bottom: 28px;
  }
  .id-stat {
    background: #EEEBE7;
    border: 1px solid #DDD9D4;
    border-radius: 2px;
    padding: 20px;
  }
  .id-stat-value {
    font-family: 'Cormorant Garamond', serif;
    font-size: 38px;
    font-weight: 300;
    color: #111111;
    line-height: 1;
    margin-bottom: 6px;
  }
  .id-stat-value.red { color: #E50000; }
  .id-stat-label {
    font-size: 9px;
    font-weight: 600;
    letter-spacing: 0.16em;
    text-transform: uppercase;
    color: #888880;
  }

  /* GRID */
  .id-grid {
    display: grid;
    grid-template-columns: 1fr 340px;
    gap: 20px;
    align-items: start;
  }

  /* SECTION */
  .id-section {
    background: #EEEBE7;
    border: 1px solid #DDD9D4;
    border-radius: 2px;
  }
  .id-section-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 18px 22px;
    border-bottom: 1px solid #DDD9D4;
  }
  .id-section-title {
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.16em;
    text-transform: uppercase;
    color: #777770;
  }

  /* CLIENT ROW */
  .id-client-row {
    display: flex;
    align-items: center;
    padding: 16px 22px;
    border-bottom: 1px solid #111;
    cursor: pointer;
    transition: background 0.15s;
    gap: 14px;
  }
  .id-client-row:last-child { border-bottom: none; }
  .id-client-row:hover { background: rgba(0,0,0,0.03); }
  .id-client-avatar {
    width: 36px;
    height: 36px;
    border-radius: 2px;
    background: #DDD9D4;
    border: 1px solid #222;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-weight: 700;
    color: #E50000;
    flex-shrink: 0;
    font-family: 'Cormorant Garamond', serif;
  }
  .id-client-info { flex: 1; min-width: 0; }
  .id-client-name {
    font-size: 12px;
    font-weight: 600;
    color: #111111;
    margin-bottom: 2px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .id-client-address {
    font-size: 10px;
    color: #888880;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .id-invite-badge {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-size: 9px;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    padding: 2px 7px;
    border-radius: 2px;
    flex-shrink: 0;
  }
  .id-invite-badge.not-sent   { background: #DDD9D4; color: #888880; border: 1px solid #222; }
  .id-invite-badge.sent       { background: #1f1a00; color: #f59e0b; border: 1px solid #3a2e00; }
  .id-invite-badge.active     { background: #1a2a1a; color: #22c55e; border: 1px solid #2a4a2a; }
  .id-invite-badge.pending    { background: #1f0a0a; color: #E50000; border: 1px solid #3a0a0a; }
  .id-client-progress {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 5px;
    flex-shrink: 0;
  }
  .id-progress-bar {
    width: 80px;
    height: 3px;
    background: #DDD9D4;
    border-radius: 2px;
    overflow: hidden;
  }
  .id-progress-fill {
    height: 100%;
    background: #E50000;
    border-radius: 2px;
    transition: width 0.3s;
  }
  .id-progress-text {
    font-size: 9px;
    font-weight: 600;
    letter-spacing: 0.1em;
    color: #888880;
  }
  .id-chevron { color: #D4D1CE; flex-shrink: 0; }

  /* SIDEBAR PANELS */
  .id-panel-item {
    padding: 14px 20px;
    border-bottom: 1px solid #111;
    display: flex;
    gap: 12px;
    align-items: flex-start;
  }
  .id-panel-item:last-child { border-bottom: none; }
  .id-panel-dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #E50000;
    margin-top: 4px;
    flex-shrink: 0;
  }
  .id-panel-dot.green { background: #22c55e; }
  .id-panel-subject {
    font-size: 11px;
    color: #555550;
    margin-bottom: 3px;
    line-height: 1.4;
  }
  .id-panel-meta {
    font-size: 9px;
    color: #999990;
    letter-spacing: 0.06em;
  }

  /* BUTTON */
  .id-btn {
    display: flex;
    align-items: center;
    gap: 7px;
    background: #E50000;
    color: #fff;
    border: none;
    border-radius: 2px;
    padding: 9px 16px;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    cursor: pointer;
    font-family: 'Montserrat', sans-serif;
    transition: background 0.2s;
  }
  .id-btn:hover { background: #cc0000; }
  .id-btn.ghost {
    background: none;
    border: 1px solid #D4D1CE;
    color: #777770;
  }
  .id-btn.ghost:hover { border-color: #888880; color: #555550; background: none; }
  .id-btn.small { padding: 6px 12px; font-size: 9px; }
  .id-btn.green-btn { background: #16a34a; }
  .id-btn.green-btn:hover { background: #15803d; }

  /* CLIENT DETAIL */
  .id-detail-header {
    display: flex;
    align-items: flex-start;
    gap: 20px;
    margin-bottom: 28px;
  }
  .id-detail-back {
    display: flex;
    align-items: center;
    gap: 6px;
    background: none;
    border: none;
    color: #888880;
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    cursor: pointer;
    padding: 0;
    font-family: 'Montserrat', sans-serif;
    margin-bottom: 16px;
    transition: color 0.2s;
  }
  .id-detail-back:hover { color: #555550; }
  .id-detail-grid {
    display: grid;
    grid-template-columns: 1fr 320px;
    gap: 20px;
    align-items: start;
  }
  .id-detail-card {
    background: #EEEBE7;
    border: 1px solid #DDD9D4;
    border-radius: 2px;
    margin-bottom: 16px;
  }
  .id-detail-card:last-child { margin-bottom: 0; }
  .id-card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 20px;
    border-bottom: 1px solid #DDD9D4;
  }
  .id-card-title {
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.16em;
    text-transform: uppercase;
    color: #888880;
  }
  .id-card-body { padding: 20px; }

  /* CRED ROW */
  .id-cred-row {
    display: flex;
    align-items: center;
    padding: 12px 0;
    border-bottom: 1px solid #111;
    gap: 12px;
  }
  .id-cred-row:last-child { border-bottom: none; }
  .id-cred-system {
    font-size: 11px;
    font-weight: 600;
    color: #555550;
    width: 120px;
    flex-shrink: 0;
  }
  .id-cred-value {
    font-size: 11px;
    color: #888880;
    flex: 1;
    font-family: monospace;
    letter-spacing: 0.04em;
  }
  .id-cred-value.revealed { color: #111111; }
  .id-cred-status {
    font-size: 9px;
    font-weight: 600;
    letter-spacing: 0.1em;
    padding: 3px 8px;
    border-radius: 2px;
  }
  .id-cred-status.pending {
    background: rgba(107,107,107,0.15);
    color: #888880;
  }
  .id-cred-status.received {
    background: rgba(34,197,94,0.1);
    color: #22c55e;
  }

  /* SERVICE ROW */
  .id-service-row {
    display: flex;
    align-items: flex-start;
    padding: 14px 0;
    border-bottom: 1px solid #111;
    gap: 12px;
  }
  .id-service-row:last-child { border-bottom: none; }
  .id-priority {
    font-size: 9px;
    font-weight: 700;
    letter-spacing: 0.1em;
    padding: 3px 7px;
    border-radius: 2px;
    flex-shrink: 0;
  }
  .id-priority.high { background: rgba(229,0,0,0.12); color: #E50000; }
  .id-priority.normal { background: rgba(107,107,107,0.12); color: #777770; }

  /* FORM */
  .id-form-group { margin-bottom: 16px; }
  .id-form-label {
    display: block;
    font-size: 9px;
    font-weight: 700;
    letter-spacing: 0.16em;
    text-transform: uppercase;
    color: #888880;
    margin-bottom: 7px;
  }
  .id-form-input, .id-form-textarea, .id-form-select {
    width: 100%;
    background: #F8F5F2;
    border: 1px solid #1e1e1e;
    border-radius: 2px;
    padding: 10px 12px;
    color: #111111;
    font-size: 12px;
    font-family: 'Montserrat', sans-serif;
    outline: none;
    transition: border-color 0.2s;
  }
  .id-form-input:focus, .id-form-textarea:focus, .id-form-select:focus { border-color: #E50000; }
  .id-form-textarea { resize: vertical; min-height: 80px; }
  .id-form-select option { background: #DDD9D4; }
  .id-systems-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 8px;
  }
  .id-system-toggle {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 12px;
    background: #F8F5F2;
    border: 1px solid #1e1e1e;
    border-radius: 2px;
    cursor: pointer;
    transition: all 0.15s;
    font-size: 11px;
    color: #888880;
    font-family: 'Montserrat', sans-serif;
    font-weight: 500;
  }
  .id-system-toggle.selected {
    border-color: #E50000;
    background: rgba(229,0,0,0.05);
    color: #111111;
  }
  .id-system-check {
    width: 14px;
    height: 14px;
    border: 1px solid #D4D1CE;
    border-radius: 2px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    transition: all 0.15s;
  }
  .id-system-toggle.selected .id-system-check {
    background: #E50000;
    border-color: #E50000;
  }

  /* MODAL */
  .id-modal-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0,0,0,0.85);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 200;
    padding: 20px;
  }
  .id-modal {
    background: #FFFFFF;
    border: 1px solid #222;
    border-radius: 2px;
    padding: 32px;
    width: 100%;
    max-width: 520px;
    max-height: 85vh;
    overflow-y: auto;
    position: relative;
  }
  .id-modal-eyebrow {
    font-size: 9px;
    font-weight: 700;
    letter-spacing: 0.22em;
    text-transform: uppercase;
    color: #E50000;
    margin-bottom: 8px;
  }
  .id-modal-title {
    font-family: 'Cormorant Garamond', serif;
    font-size: 28px;
    font-weight: 300;
    color: #111111;
    margin-bottom: 24px;
  }
  .id-modal-close {
    position: absolute;
    top: 16px;
    right: 16px;
    background: none;
    border: none;
    color: #888880;
    cursor: pointer;
    padding: 4px;
    transition: color 0.2s;
  }
  .id-modal-close:hover { color: #111111; }
  .id-modal-actions {
    display: flex;
    gap: 10px;
    justify-content: flex-end;
    margin-top: 24px;
  }

  /* NOTES */
  .id-notes-area {
    width: 100%;
    background: #F8F5F2;
    border: 1px solid #1e1e1e;
    border-radius: 2px;
    padding: 12px;
    color: #111111;
    font-size: 12px;
    font-family: 'Montserrat', sans-serif;
    outline: none;
    resize: vertical;
    min-height: 100px;
    transition: border-color 0.2s;
  }
  .id-notes-area:focus { border-color: #E50000; }

  /* COPY TOAST */
  .id-toast {
    position: fixed;
    bottom: 24px;
    right: 24px;
    background: #DDD9D4;
    border: 1px solid #D4D1CE;
    border-radius: 2px;
    padding: 12px 18px;
    font-size: 11px;
    color: #111111;
    display: flex;
    align-items: center;
    gap: 8px;
    z-index: 300;
    animation: slideUp 0.2s ease;
  }
  @keyframes slideUp {
    from { opacity: 0; transform: translateY(8px); }
    to   { opacity: 1; transform: translateY(0); }
  }

  .id-empty {
    padding: 32px 20px;
    text-align: center;
    font-size: 11px;
    color: #D4D1CE;
    letter-spacing: 0.06em;
  }

  .id-info-row {
    display: flex;
    gap: 8px;
    margin-bottom: 8px;
    font-size: 11px;
  }
  .id-info-label { color: #999990; font-weight: 600; width: 70px; flex-shrink: 0; }
  .id-info-value { color: #555550; }

  @media (max-width: 1024px) {
    .id-stats { grid-template-columns: repeat(2,1fr); }
    .id-grid, .id-detail-grid { grid-template-columns: 1fr; }
    .id-sidebar { display: none; }
    .id-main { padding: 20px; padding-bottom: 80px; }
    .id-mobile-tabs { display: flex !important; }
  }
  .id-mobile-tabs {
    display: none;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 64px;
    background: #F8F5F2;
    border-top: 1px solid #DDD9D4;
    z-index: 9999;
    align-items: stretch;
  }
  .id-mobile-tab {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
    background: none;
    border: none;
    cursor: pointer;
    color: #888880;
    font-size: 8px;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    padding: 8px 4px;
    position: relative;
    transition: color 0.15s;
  }
  .id-mobile-tab.active { color: #E50000; }
  .id-mobile-tab:hover { color: #555550; }
  .id-mobile-tab-badge {
    position: absolute;
    top: 8px;
    right: calc(50% - 14px);
    background: #E50000;
    color: #fff;
    font-size: 8px;
    font-weight: 700;
    min-width: 14px;
    height: 14px;
    border-radius: 7px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 3px;
  }
`;

// ── HELPERS ──────────────────────────────────────────────────────────────────
function initials(name) {
  return name.split(" ").filter(Boolean).map(w => w[0]).slice(0, 2).join("");
}

function credProgress(client) {
  const total = client.systems.length;
  const done = client.systems.filter(s => client.credentials[s]).length;
  return { done, total, pct: total ? Math.round((done / total) * 100) : 0 };
}

// ── NEW CLIENT MODAL ─────────────────────────────────────────────────────────
function inviteBadge(status) {
  const map = {
    'not-sent': { label: 'No Invite', cls: 'not-sent' },
    'sent':     { label: 'Invite Sent', cls: 'sent' },
    'active':   { label: 'Portal Active', cls: 'active' },
    'pending':  { label: 'Setup Pending', cls: 'pending' },
  };
  const { label, cls } = map[status] || map['not-sent'];
  return <span className={`id-invite-badge ${cls}`}>{label}</span>;
}

function NewClientModal({ onClose, onSave }) {
  const [form, setForm] = useState({ ...EMPTY_CLIENT, installDate: new Date().toISOString().slice(0,10) });
  const set = (k, v) => setForm(p => ({ ...p, [k]: v }));
  const [customSystems, setCustomSystems] = useState([""]);
  const updateCustom = (i, val) => {
    const updated = [...customSystems];
    updated[i] = val;
    if (val && i === customSystems.length - 1) updated.push("");
    setCustomSystems(updated);
  };
  const toggleSystem = (id) => {
    set("systems", form.systems.includes(id) ? form.systems.filter(s => s !== id) : [...form.systems, id]);
  };
  const handleSave = () => {
    if (!form.name.trim()) return;
    const allSystems = [...form.systems, ...customSystems.filter(s => s.trim()).map(s => s.trim().toLowerCase().replace(/\s+/g, "-"))];
    const allSystemNames = [...ALL_SYSTEMS.filter(s => form.systems.includes(s.id)).map(s => s.name), ...customSystems.filter(s => s.trim())];
    if (window._customSystemNames) window._customSystemNames = allSystemNames;
    onSave({
      ...form,
      id: Date.now(),
      credentials: {},
      serviceRequests: [],
      portalLink: `https://smarttechutah.com/portal/${form.name.toLowerCase().replace(/\s+/g,"-").replace(/[^a-z-]/g,"")}-${Date.now().toString().slice(-4)}`,
    });
  };
  return (
    <div className="id-modal-overlay" onClick={onClose}>
      <div className="id-modal" onClick={e => e.stopPropagation()}>
        <button className="id-modal-close" onClick={onClose}><Icon path={icons.close} size={16}/></button>
        <div className="id-modal-eyebrow">New Client</div>
        <div className="id-modal-title">Add Client</div>
        <div style={{display:"grid", gridTemplateColumns:"1fr 1fr", gap:14}}>
          <div className="id-form-group" style={{gridColumn:"1/-1"}}>
            <label className="id-form-label">Full Name / Household</label>
            <input className="id-form-input" placeholder="e.g. Marcus & Sarah Whitfield" value={form.name} onChange={e => set("name", e.target.value)}/>
          </div>
          <div className="id-form-group">
            <label className="id-form-label">System Name</label>
            <input className="id-form-input" placeholder="e.g. Sanchez Residence" value={form.systemName} onChange={e => set("systemName", e.target.value)}/>
          </div>
          <div className="id-form-group" style={{gridColumn:"1/-1"}}>
            <label className="id-form-label">Property Address</label>
            <input className="id-form-input" placeholder="123 Main St, Salt Lake City, UT" value={form.address} onChange={e => set("address", e.target.value)}/>
          </div>
          <div className="id-form-group">
            <label className="id-form-label">Phone</label>
            <input className="id-form-input" placeholder="801-555-0000" value={form.phone} onChange={e => set("phone", e.target.value)}/>
          </div>
          <div className="id-form-group">
            <label className="id-form-label">Email</label>
            <input className="id-form-input" type="email" placeholder="client@email.com" value={form.email} onChange={e => set("email", e.target.value)}/>
          </div>
          <div className="id-form-group">
            <label className="id-form-label">Install Date</label>
            <input className="id-form-input" type="date" value={form.installDate} onChange={e => set("installDate", e.target.value)}/>
          </div>
        </div>
        <div className="id-form-group">
          <label className="id-form-label">Systems to Enable</label>
          <div className="id-systems-grid">
            {ALL_SYSTEMS.map(sys => (
              <button key={sys.id} className={`id-system-toggle ${form.systems.includes(sys.id) ? "selected" : ""}`} onClick={() => toggleSystem(sys.id)}>
                <div className="id-system-check">
                  {form.systems.includes(sys.id) && <Icon path={icons.check} size={9} stroke="#fff" strokeWidth={3}/>}
                </div>
                {sys.name}
              </button>
            ))}
            {customSystems.map((val, i) => (
              <div key={`custom-${i}`}
                className={`id-system-toggle ${val && form.systems.includes(`custom-${i}`) ? "selected" : ""}`}
                style={{cursor: val ? "pointer" : "default"}}
                onClick={() => val && toggleSystem(`custom-${i}`)}>
                <div className="id-system-check">
                  {val && form.systems.includes(`custom-${i}`) && <Icon path={icons.check} size={9} stroke="#fff" strokeWidth={3}/>}
                </div>
                <input
                  className="id-form-input"
                  placeholder="Add system..."
                  value={val}
                  onClick={e => e.stopPropagation()}
                  onChange={e => updateCustom(i, e.target.value)}
                  style={{background:"transparent", border:"none", padding:0, width:"100%", color: val ? "#111111" : "#888880", cursor:"text"}}
                />
              </div>
            ))}
          </div>
        </div>
        <div className="id-modal-actions">
          <button className="id-btn ghost" onClick={onClose}>Cancel</button>
          <button className="id-btn" onClick={handleSave}>Create Client</button>
        </div>
      </div>
    </div>
  );
}

function CredentialsView({ clients, onSelectClient }) {
  const [search, setSearch] = useState('');

  const clientsWithCreds = clients
    .filter(c => Object.keys(c.credentials || {}).length > 0)
    .sort((a, b) => a.name.localeCompare(b.name))
    .filter(c => !search || c.name.toLowerCase().includes(search.toLowerCase()));

  return (
    <div>
      <div style={{marginBottom:24}}>
        <div style={{fontFamily:"'Cormorant Garamond', serif", fontSize:28, fontWeight:300, color:"#111111", marginBottom:4}}>Credentials</div>
        <div style={{fontSize:10, color:"#888880", letterSpacing:"0.1em"}}>{clientsWithCreds.length} clients with stored credentials</div>
      </div>
      <input
        className="id-search"
        placeholder="Search clients..."
        value={search}
        onChange={e => setSearch(e.target.value)}
        style={{marginBottom:24, width:'100%', maxWidth:400}}
      />
      {clientsWithCreds.length === 0 && <div style={{color:"#888880", fontSize:13}}>No credentials stored yet.</div>}
      <div style={{display:"flex", flexDirection:"column", gap:8}}>
        {clientsWithCreds.map(client => (
          <div key={client.id}
            onClick={() => onSelectClient(client)}
            style={{background:"#FFFFFF", border:"1px solid #1e1e1e", borderRadius:2, padding:"14px 16px", cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"space-between"}}
            onMouseOver={e => e.currentTarget.style.background="rgba(0,0,0,0.03)"}
            onMouseOut={e => e.currentTarget.style.background="#FFFFFF"}
          >
            <div>
              <div style={{fontSize:13, color:"#111111", marginBottom:4}}>{client.name}</div>
              <div style={{fontSize:10, color:"#888880", letterSpacing:"0.08em"}}>{Object.keys(client.credentials).length} credential{Object.keys(client.credentials).length !== 1 ? 's' : ''} stored</div>
            </div>
            <Icon path={icons.chevron} size={14}/>
          </div>
        ))}
      </div>
    </div>
  );
}

function ServiceRequestsView({ clients, onSelectClient }) {
  const [filter, setFilter] = useState('open');
  const allRequests = clients.flatMap(c =>
    (c.serviceRequests || []).map(r => ({ ...r, client: c }))
  );
  const filtered = allRequests.filter(r => filter === 'open' ? !r.resolved : r.resolved);
  const sorted = filtered.sort((a, b) => new Date(b.date) - new Date(a.date));

  return (
    <div>
      <div style={{marginBottom:24}}>
        <div style={{fontFamily:"'Cormorant Garamond', serif", fontSize:28, fontWeight:300, color:"#111111", marginBottom:4}}>Service Requests</div>
        <div style={{fontSize:10, color:"#888880", letterSpacing:"0.1em"}}>{allRequests.filter(r => !r.resolved).length} open · {allRequests.filter(r => r.resolved).length} resolved</div>
      </div>
      <div style={{display:"flex", gap:8, marginBottom:24}}>
        <button onClick={() => setFilter('open')} className={`id-btn${filter === 'open' ? '' : ' ghost'}`} style={{fontSize:10}}>Open</button>
        <button onClick={() => setFilter('resolved')} className={`id-btn${filter === 'resolved' ? '' : ' ghost'}`} style={{fontSize:10}}>Resolved</button>
      </div>
      {sorted.length === 0 && (
        <div style={{color:"#888880", fontSize:13}}>No {filter} service requests.</div>
      )}
      <div style={{display:"flex", flexDirection:"column", gap:8}}>
        {sorted.map(req => (
          <div key={req.id}
            onClick={() => onSelectClient(req.client, req)}
            style={{background:"#FFFFFF", border:"1px solid #1e1e1e", borderRadius:2, padding:"14px 16px", cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"space-between"}}
          >
            <div>
              <div style={{fontSize:11, color:"#E50000", fontWeight:700, letterSpacing:"0.1em", textTransform:"uppercase", marginBottom:4}}>{req.client.name}</div>
              <div style={{fontSize:13, color:"#111111", marginBottom:4}}>{req.subject}</div>
              <div style={{fontSize:10, color:"#888880", letterSpacing:"0.06em"}}>
                {req.date}
                {req.resolved && req.resolvedAt && ` · Resolved ${new Date(req.resolvedAt).toLocaleDateString('en-US', {month:'short', day:'numeric', year:'numeric'})}`}
              </div>
            </div>
            <div style={{display:"flex", alignItems:"center", gap:8}}>
              <span className={`id-priority ${(req.priority || 'normal').toLowerCase()}`}>{req.priority || 'Normal'}</span>
              <span style={{fontSize:9, fontWeight:700, letterSpacing:"0.1em", textTransform:"uppercase", color: req.resolved ? "#999990" : "#E50000", background: req.resolved ? "#DDD9D4" : "#1a0000", padding:"3px 8px", borderRadius:2}}>
                {req.resolved ? "Resolved" : "Open"}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

function ServiceRequestModal({ request, clientName, clientPhone, onClose, onResolve, onUpdate }) {
  const [reply, setReply] = useState("");
  const [thread, setThread] = useState([]);
  const threadEndRef = useRef(null);

  const loadThread = async () => {
    const { data } = await supabase.from("service_requests").select("thread, message, created_at").eq("id", request.id).single();
    if (data) {
      setThread(data.thread && data.thread.length > 0 ? data.thread : [{ from: "client", text: data.message || "", time: new Date(data.created_at).toLocaleDateString("en-US", {month:"short", day:"numeric", year:"numeric"}) }]);
    }
  };

  useEffect(() => {
    loadThread();
    const interval = setInterval(loadThread, 5000);
    return () => clearInterval(interval);
  }, [request.id]);

  useEffect(() => {
    threadEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [thread]);

  const sendReply = async () => {
    if (!reply.trim()) return;
    const newMsg = { from: "installer", text: reply.trim(), time: new Date().toLocaleDateString("en-US", {month:"short", day:"numeric", year:"numeric"}) };
    const updated = [...thread, newMsg];
    setThread(updated);
    setReply("");
    onUpdate(request.id, { thread: updated });
    const { error } = await supabase.from("service_requests").update({ thread: updated }).eq("id", request.id);
    if (error) console.error("Thread save error:", error);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && (e.metaKey || e.ctrlKey)) sendReply();
  };

  return (
    <div className="id-modal-overlay" onClick={onClose}>
      <div className="id-modal" onClick={e => e.stopPropagation()} style={{maxWidth:580, padding:"28px 28px 24px"}}>
        <button className="id-modal-close" onClick={onClose}><Icon path={icons.close} size={16}/></button>
        <div style={{display:"flex", alignItems:"center", gap:8, marginBottom:6}}>
          <span className={`id-priority ${request.priority.toLowerCase()}`}>{request.priority}</span>
          {request.system && <span style={{fontSize:9, color:"#888880", letterSpacing:"0.1em"}}>{request.system}</span>}
          {request.resolved && <span className="id-priority normal" style={{marginLeft:"auto"}}>Resolved</span>}
        </div>
        <div className="id-modal-eyebrow">{clientName}</div>
        <div style={{fontFamily:"'Cormorant Garamond', serif", fontSize:24, fontWeight:300, color:"#111111", marginBottom:4}}>{request.subject}</div>
        <div style={{fontSize:10, color:"#999990", marginBottom:20, letterSpacing:"0.06em"}}>{request.date}</div>

        <div style={{background:"#F8F5F2", border:"1px solid #1e1e1e", borderRadius:2, marginBottom:16, maxHeight:280, overflowY:"auto", padding:"4px 0"}}>
          {thread.map((msg, i) => (
            <div key={i} style={{padding:"12px 16px", borderBottom: i < thread.length-1 ? "1px solid #111" : "none"}}>
              <div style={{display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:6}}>
                <span style={{fontSize:9, fontWeight:700, letterSpacing:"0.14em", textTransform:"uppercase", color: msg.from === "installer" ? "#E50000" : "#777770"}}>
                  {msg.from === "installer" ? "Smart Tech Utah" : clientName}
                </span>
                <span style={{fontSize:9, color:"#D4D1CE"}}>{msg.time}</span>
              </div>
              <div style={{fontSize:12, color: msg.from === "installer" ? "#555550" : "#8a8a8a", lineHeight:1.7}}>{msg.text}</div>
            </div>
          ))}
          <div ref={threadEndRef}/>
        </div>

        {!request.resolved && (
          <div style={{marginBottom:16}}>
            <div style={{fontSize:9, fontWeight:700, letterSpacing:"0.16em", textTransform:"uppercase", color:"#888880", marginBottom:8}}>Reply to Client</div>
            <textarea
              className="id-notes-area"
              placeholder={`Message ${clientName}... (⌘+Enter to send)`}
              value={reply}
              onChange={e => setReply(e.target.value)}
              onKeyDown={handleKeyDown}
              style={{minHeight:80, marginBottom:8}}
            />
            <div style={{display:"flex", alignItems:"center", gap:8, justifyContent:"space-between", flexWrap:"wrap"}}>
              <div style={{fontSize:9, color:"#D4D1CE", letterSpacing:"0.06em"}}>
                {clientPhone ? `Notification → SMS to ${clientPhone}` : "Notification → Email"}
              </div>
              <button className="id-btn small" onClick={sendReply} disabled={!reply.trim()} style={{opacity: reply.trim() ? 1 : 0.4}}>Send Reply</button>
            </div>
          </div>
        )}

        <div className="id-modal-actions" style={{marginTop:8}}>
          <button className="id-btn ghost" onClick={onClose}>Close</button>
          {!request.resolved && (
            <button className="id-btn green-btn" onClick={() => { onResolve(request.id); onClose(); }}>
              <Icon path={icons.resolve} size={13}/> Mark Resolved
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
// ── CLIENT DETAIL VIEW ───────────────────────────────────────────────────────
function ClientDetail({ client, onBack, onUpdate, onCopy, onSendInvite, onDelete, onToast, initialRequest, onClearInitialRequest, isInstaller }) {
  const showToast = onToast;
  const [activeTab, setActiveTab] = useState('overview');
  const [devices, setDevices] = useState([]);
  const [showAddDevice, setShowAddDevice] = useState(false);
  const [deviceForm, setDeviceForm] = useState({ make: '', model: '', category: '', notes: '' });
  const [manualUrl, setManualUrl] = useState('');
  // Equipment library for dropdowns
  const [equipmentLibrary, setEquipmentLibrary] = useState([]);
  // Proposal PDF drop state
  const [proposalUploading, setProposalUploading] = useState(false);
  const [proposalExtracting, setProposalExtracting] = useState(false);
  const [documents, setDocuments] = useState([]);
  const [uploadingDoc, setUploadingDoc] = useState(false);
  const [showAddUrl, setShowAddUrl] = useState(false);
  const [urlForm, setUrlForm] = useState({ name: '', url: '', category: 'General' });
  const [networkInfo, setNetworkInfo] = useState({ ssid: '', wifi_password: '', router_ip: '', router_user: '', router_password: '', notes: '' });
  const [savingNetwork, setSavingNetwork] = useState(false);

  useEffect(() => {
    const loadDevices = async () => {
      const { data } = await supabase.from('devices').select('*').eq('client_id', client.id).order('created_at');
      if (data) setDevices(data);
    };
    const loadDocuments = async () => {
      const { data } = await supabase.from('documents').select('*').eq('client_id', client.id).order('created_at');
      if (data) setDocuments(data);
    };
    const loadNetwork = async () => {
      const { data } = await supabase.from('clients').select('network_info').eq('id', client.id).single();
      if (data?.network_info) setNetworkInfo(data.network_info);
    };
    const loadEquipmentLibrary = async () => {
      const { data } = await supabase.from('equipment_library').select('*').order('category,make,model');
      if (data) setEquipmentLibrary(data);
    };
    loadDevices();
    loadDocuments();
    loadNetwork();
    loadEquipmentLibrary();
  }, [client.id]);

  // Derived dropdown options based on current deviceForm selections
  const libCategories = [...new Set(equipmentLibrary.map(i => i.category?.trim()))].filter(Boolean).sort();
  const libMakes = deviceForm.category
    ? [...new Set(equipmentLibrary.filter(i => i.category?.trim() === deviceForm.category?.trim()).map(i => i.make?.trim()))].filter(Boolean).sort()
    : [];
  const libModels = deviceForm.category && deviceForm.make
    ? equipmentLibrary.filter(i => i.category?.trim() === deviceForm.category?.trim() && i.make?.trim() === deviceForm.make?.trim()).map(i => i.model?.trim()).filter(Boolean).sort()
    : [];

  const handleCategoryChange = (cat) => {
    setDeviceForm(p => ({ ...p, category: cat, make: '', model: '' }));
    setManualUrl('');
  };
  const handleMakeChange = (make) => {
    setDeviceForm(p => ({ ...p, make, model: '' }));
    setManualUrl('');
  };
  const handleModelChange = (model) => {
    setDeviceForm(p => ({ ...p, model }));
    // Auto-fill manual URL from library
    const match = equipmentLibrary.find(i =>
      i.category?.trim() === deviceForm.category?.trim() &&
      i.make?.trim() === deviceForm.make?.trim() &&
      i.model?.trim() === model?.trim()
    );
    if (match?.manual_url) setManualUrl(match.manual_url);
    else setManualUrl('');
  };

  // Proposal PDF drop → extract devices and add to this client
  const handleProposalPdf = async (file) => {
    if (!file || file.type !== 'application/pdf') return;
    setProposalUploading(true);
    showToast('Reading proposal PDF...');
    const arrayBuffer = await file.arrayBuffer();
    const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;
    let pdfText = '';
    for (let i = 1; i <= pdf.numPages; i++) {
      const page = await pdf.getPage(i);
      const tc = await page.getTextContent();
      pdfText += tc.items.map(item => item.str).join(' ') + '\n';
    }
    setProposalUploading(false);
    setProposalExtracting(true);
    showToast('Extracting devices with AI...');
    try {
      const response = await fetch('/.netlify/functions/extract-equipment', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ pdfText: pdfText.substring(0, 25000), model: 'claude-sonnet-4-5', max_tokens: 4000 })
      });
      if (!response.ok) {
        const errText = await response.text();
        showToast('Function error ' + response.status + ': ' + errText.substring(0, 120));
        setProposalExtracting(false);
        return;
      }
      const data = await response.json();
      const text = data.content?.[0]?.text || '[]';
      let extracted = [];
      try {
        const cleanText = text.replace(/^```json\s*/m, "").replace(/\s*```\s*$/m, "").trim();
        extracted = JSON.parse(cleanText);
      } catch(e) {
        showToast('Parse error: ' + text.substring(0, 100));
        setProposalExtracting(false);
        return;
      }
      if (!Array.isArray(extracted) || extracted.length === 0) {
        showToast('No equipment found in PDF');
        setProposalExtracting(false);
        return;
      }
      showToast(`Found ${extracted.length} devices, adding to client...`);
      let added = 0;
      for (const item of extracted) {
        // Look up manual URL from equipment library first
        const libMatch = equipmentLibrary.find(i =>
          i.make?.toLowerCase() === item.make?.toLowerCase() &&
          i.model?.toLowerCase() === item.model?.toLowerCase()
        );
        const { data: newDevice, error } = await supabase.from('devices').insert([{
          client_id: client.id,
          make: item.make,
          model: item.model,
          category: item.category || 'Other',
          manual_url: libMatch?.manual_url || '',
          notes: item.description || '',
        }]).select().single();
        if (!error && newDevice) {
          setDevices(p => [...p, newDevice]);
          added++;
        }
      }
      showToast(`Added ${added} devices to client profile`);
    } catch(err) {
      showToast('Error: ' + err.message);
    }
    setProposalExtracting(false);
  };



  const saveDevice = async () => {
    if (!deviceForm.make || !deviceForm.model) return;
    const { data, error } = await supabase.from('devices').insert([{
      client_id: client.id,
      make: deviceForm.make,
      model: deviceForm.model,
      category: deviceForm.category,
      manual_url: manualUrl,
      notes: deviceForm.notes,
    }]).select().single();
    if (!error && data) {
      setDevices(p => [...p, data]);
      setDeviceForm({ make: '', model: '', category: '', notes: '' });
      setManualUrl('');
      setShowAddDevice(false);
      showToast('Device added');
    }
  };

  const deleteDevice = async (deviceId) => {
    await supabase.from('devices').delete().eq('id', deviceId);
    setDevices(p => p.filter(d => d.id !== deviceId));
  };

  const uploadDocument = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setUploadingDoc(true);
    const fileName = `${client.id}/${Date.now()}_${file.name}`;
    const { error: uploadError } = await supabase.storage.from('documents').upload(fileName, file);
    if (uploadError) { showToast('Upload failed: ' + uploadError.message); setUploadingDoc(false); return; }
    const { data: { publicUrl } } = supabase.storage.from('documents').getPublicUrl(fileName);
    const { data, error } = await supabase.from('documents').insert([{
      client_id: client.id,
      name: file.name.replace(/\.[^.]+$/, ''),
      url: publicUrl,
      category: 'Upload',
    }]).select().single();
    if (!error && data) {
      setDocuments(p => [...p, data]);
      showToast('Document uploaded');
    }
    setUploadingDoc(false);
  };

  const deleteDocument = async (docId) => {
    await supabase.from('documents').delete().eq('id', docId);
    setDocuments(p => p.filter(d => d.id !== docId));
  };

  const saveNetwork = async () => {
    setSavingNetwork(true);
    await supabase.from('clients').update({ network_info: networkInfo }).eq('id', client.id);
    setSavingNetwork(false);
    showToast('Network info saved');
  };

  const addUrlDocument = async () => {
    if (!urlForm.name || !urlForm.url) return;
    const { data, error } = await supabase.from('documents').insert([{
      client_id: client.id,
      name: urlForm.name,
      url: urlForm.url,
      category: urlForm.category,
    }]).select().single();
    if (!error && data) {
      setDocuments(p => [...p, data]);
      setUrlForm({ name: '', url: '', category: 'General' });
      setShowAddUrl(false);
      showToast('Document added');
    }
  };
  const [showPasswords, setShowPasswords] = useState({});
  const [editingNotes, setEditingNotes] = useState(false);
  const [notes, setNotes] = useState(client.notes);
  const [editing, setEditing] = useState(false);
  const [editForm, setEditForm] = useState({ name: client.name, systemName: client.systemName || "", address: client.address, phone: client.phone, email: client.email, installDate: client.installDate, systems: client.systems || [] });
  const [customEditSystems, setCustomEditSystems] = useState([""]);
  const toggleEditSystem = (id) => setEditForm(p => ({ ...p, systems: p.systems.includes(id) ? p.systems.filter(s => s !== id) : [...p.systems, id] }));
  const updateCustomEdit = (i, val) => {
    const updated = [...customEditSystems];
    updated[i] = val;
    if (val && i === customEditSystems.length - 1) updated.push("");
    setCustomEditSystems(updated);
  };
  const [selectedRequest, setSelectedRequest] = useState(null);
  const openRequest = async (req) => {
    setSelectedRequest(req);
    await supabase.from("service_requests").update({ last_read_installer: new Date().toISOString() }).eq("id", req.id);
  };

  // Auto-open request when navigating from dashboard panel
  useState(() => {
    if (initialRequest) {
      const found = client.serviceRequests.find(r => r.id === initialRequest.id);
      if (found) setSelectedRequest(found);
      if (onClearInitialRequest) onClearInitialRequest();
    }
  });
  const { done, total, pct } = credProgress(client);

  const togglePassword = (id) => setShowPasswords(p => ({ ...p, [id]: !p[id] }));

  const saveNotes = () => {
    onUpdate({ ...client, notes });
    setEditingNotes(false);
  };

  const saveEdit = async () => {
    const allSystems = [...editForm.systems, ...customEditSystems.filter(s => s.trim()).map(s => s.trim().toLowerCase().replace(/\s+/g, "-"))];
    const emailChanged = editForm.email !== client.email;
    const newInviteStatus = emailChanged ? 'not-sent' : client.inviteStatus;
    const updatedClient = { ...client, ...editForm, systems: allSystems, inviteStatus: newInviteStatus };
    onUpdate(updatedClient);
    await supabase.from("clients").update({
      name: editForm.name,
      address: editForm.address,
      phone: editForm.phone,
      email: editForm.email,
      install_date: editForm.installDate,
      systems: allSystems,
      system_name: editForm.systemName || "",
      ...(emailChanged ? { invite_status: 'not-sent' } : {})
    }).eq("id", client.id);
    setEditing(false);
    if (emailChanged) onToast("Email updated — invite status reset. Send a new invite when ready.");
  };
  const resolveRequest = async (reqId) => {
    await supabase.from("service_requests").update({ resolved: true, resolved_at: new Date().toISOString() }).eq("id", reqId);
    onUpdate({
      ...client,
      serviceRequests: client.serviceRequests.map(r => r.id === reqId ? { ...r, resolved: true } : r),
    });
  };
  const _saveRequestNote = async (reqId, note) => {
    await supabase.from("service_requests").update({ internal_note: note }).eq("id", reqId);
    onUpdate({
      ...client,
      serviceRequests: client.serviceRequests.map(r => r.id === reqId ? { ...r, internalNote: note } : r),
    });
  };

  const openRequests = client.serviceRequests.filter(r => !r.resolved);
  const resolvedRequests = client.serviceRequests.filter(r => r.resolved);

  return (
    <div>
      <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:4}}>
        <button className="id-detail-back" onClick={onBack}>
          <Icon path={icons.back} size={12}/> Back to Clients
        </button>
        {!isInstaller && (
        <button onClick={() => {
          if (window.confirm(`Are you sure you want to delete ${client.name}? This cannot be undone.`)) {
            onDelete(client);
          }
        }} style={{fontSize:9,fontWeight:700,letterSpacing:'0.08em',textTransform:'uppercase',background:'transparent',color:'#888880',border:'1px solid #D4D1CE',borderRadius:2,padding:'4px 10px',cursor:'pointer'}}>
          Delete Client
        </button>
        )}
      </div>

      {/* Header */}
      <div style={{display:"flex", alignItems:"flex-start", justifyContent:"space-between", marginBottom:28, flexWrap:"wrap", gap:14}}>
        <div>
          <div className="id-page-eyebrow">Client Profile</div>
          <div className="id-page-title" style={{display:'flex',alignItems:'center',gap:12}}>
            {client.name}
            <div style={{display:'flex',gap:6,alignItems:'center'}}>
              {inviteBadge(client.inviteStatus || 'not-sent')}
              {!isInstaller && (
                <button onClick={() => onSendInvite(client)}
                  style={{fontSize:9,fontWeight:700,letterSpacing:'0.08em',textTransform:'uppercase',background:'#E50000',color:'#fff',border:'none',borderRadius:2,padding:'3px 10px',cursor:'pointer'}}>
                  {client.inviteStatus === 'active' ? 'Resend Invite' : client.inviteStatus === 'sent' ? 'Resend Invite' : 'Send Invite'}
                </button>
              )}
              {!isInstaller && client.inviteStatus === 'sent' && (
                <span style={{fontSize:9,color:'#777770',letterSpacing:'0.06em'}}>Awaiting setup</span>
              )}
            </div>
          </div>
          <div style={{fontSize:11, color:"#888880", marginTop:4}}>{client.address}</div>
        </div>
        <div style={{display:"flex", gap:10, flexWrap:"wrap"}}>
          <button className="id-btn ghost small" onClick={() => setEditing(true)}>
            <Icon path={icons.edit} size={12}/> Edit
          </button>
          <button className="id-btn ghost small" onClick={() => onCopy(client.portalLink)}>
            <Icon path={icons.copy} size={12}/> Copy Portal Link
          </button>
        </div>
      </div>

      {/* TABS */}
      <div style={{display:'flex',gap:0,borderBottom:'1px solid #DDD9D4',marginBottom:24}}>
        {[['overview','Overview'],['portal','Portal Editor']].map(([id,label]) => (
          <button key={id} onClick={() => setActiveTab(id)} style={{
            background:'none', border:'none', borderBottom: activeTab===id ? '2px solid #E50000' : '2px solid transparent',
            color: activeTab===id ? '#111111' : '#888880', fontSize:11, fontWeight:600,
            letterSpacing:'0.1em', textTransform:'uppercase', padding:'10px 20px',
            cursor:'pointer', marginBottom:-1, transition:'color 0.2s'
          }}>{label}</button>
        ))}
      </div>

      {activeTab === 'overview' && <div className="id-detail-grid">
        {/* LEFT COLUMN */}
        <div>
          {/* Credential Status */}
          <div className="id-detail-card">
            <div className="id-card-header">
              <span className="id-card-title">Credentials</span>
              <span style={{fontSize:11, color: pct===100?"#22c55e":"#E50000", fontWeight:600}}>{done}/{total} Received</span>
            </div>
            <div className="id-card-body" style={{padding:"0 20px"}}>
              <div style={{display:"flex", padding:"8px 0 4px", borderBottom:"1px solid #DDD9D4", marginBottom:4}}>
                <div style={{width:120, flexShrink:0, fontSize:9, fontWeight:700, letterSpacing:"0.12em", textTransform:"uppercase", color:"#999990"}}>Credential</div>
                <div style={{flex:1, fontSize:9, fontWeight:700, letterSpacing:"0.12em", textTransform:"uppercase", color:"#999990"}}>Username</div>
                <div style={{flex:1, fontSize:9, fontWeight:700, letterSpacing:"0.12em", textTransform:"uppercase", color:"#999990"}}>Password</div>
              </div>
              {client.systems.map(sysId => {
                const sys = ALL_SYSTEMS.find(s => s.id === sysId);
                const cred = client.credentials[sysId];
                return (
                  <div key={sysId} className="id-cred-row">
                    <div className="id-cred-system">{sys?.name}</div>
                    {cred ? (
                      <>
                        <div style={{flex:1, fontSize:12, color:"#555550",
                          filter: isInstaller ? 'blur(4px)' : 'none',
                          userSelect: isInstaller ? 'none' : 'auto',
                          WebkitUserSelect: isInstaller ? 'none' : 'auto',
                          transition:'filter 0.2s'
                        }}
                          onMouseDown={isInstaller ? (e) => { e.currentTarget.style.filter='none'; } : undefined}
                          onMouseUp={isInstaller ? (e) => { e.currentTarget.style.filter='blur(4px)'; } : undefined}
                          onTouchStart={isInstaller ? (e) => { e.currentTarget.style.filter='none'; } : undefined}
                          onTouchEnd={isInstaller ? (e) => { e.currentTarget.style.filter='blur(4px)'; } : undefined}
                          title={isInstaller ? 'Hold to reveal' : ''}
                        >{cred.email || cred.username || "—"}</div>
                        <div style={{flex:1, display:"flex", alignItems:"center", gap:8}}>
                          <span style={{fontSize:12, color:"#555550", fontFamily:"monospace",
                            filter: isInstaller ? 'blur(4px)' : 'none',
                            userSelect: isInstaller ? 'none' : 'auto',
                            WebkitUserSelect: isInstaller ? 'none' : 'auto',
                            transition:'filter 0.2s'
                          }}
                            onMouseDown={isInstaller ? (e) => { e.currentTarget.style.filter='none'; } : undefined}
                            onMouseUp={isInstaller ? (e) => { e.currentTarget.style.filter='blur(4px)'; } : undefined}
                            onTouchStart={isInstaller ? (e) => { e.currentTarget.style.filter='none'; } : undefined}
                            onTouchEnd={isInstaller ? (e) => { e.currentTarget.style.filter='blur(4px)'; } : undefined}
                            title={isInstaller ? 'Hold to reveal' : ''}
                          >{showPasswords[sysId] ? (cred.password || "—") : (cred.password ? "••••••••" : "—")}</span>
                          {cred.password && !isInstaller && <button className="id-btn ghost small" style={{padding:"4px 8px"}} onClick={() => togglePassword(sysId)}><Icon path={showPasswords[sysId] ? icons.eyeOff : icons.eye} size={12}/></button>}
                          {isInstaller && cred.password && <span style={{fontSize:8,color:'#888880',letterSpacing:'0.06em'}}>hold to reveal</span>}
                        </div>
                        <span className="id-cred-status received">Received</span>
                      </>











                    ) : (
                      <>
                        <div className="id-cred-value">—</div>
                        <span className="id-cred-status pending">Pending</span>
                      </>
                    )}
                  </div>
                );
              })}
            </div>
          </div>

          {/* Service Requests */}
          <div className="id-detail-card">
            <div className="id-card-header">
              <span className="id-card-title">Service Requests</span>
              {openRequests.length > 0 && <span style={{fontSize:11, color:"#E50000", fontWeight:600}}>{openRequests.length} Open</span>}
            </div>
            <div style={{padding:"0 20px"}}>
              {client.serviceRequests.length === 0 && <div className="id-empty">No service requests</div>}
              {openRequests.map(req => (
                <div key={req.id} className="id-service-row" style={{cursor:"pointer"}} onClick={() => setSelectedRequest(req)}
                  onMouseOver={e => e.currentTarget.style.background="rgba(0,0,0,0.03)"}
                  onMouseOut={e => e.currentTarget.style.background="transparent"}>
                  <span className={`id-priority ${req.priority.toLowerCase()}`}>{req.priority}</span>
                  <div style={{flex:1}}>
                    <div style={{fontSize:11, color:"#555550", marginBottom:3}}>{req.subject}</div>
                    <div style={{fontSize:9, color:"#999990"}}>{req.date} {req.system ? `· ${req.system}` : ""}</div>
                  </div>
                  <Icon path={icons.chevron} size={13} stroke="#D4D1CE"/>
                </div>
              ))}
              {resolvedRequests.map(req => (
                <div key={req.id} className="id-service-row" style={{opacity:0.5, cursor:"pointer"}} onClick={() => setSelectedRequest(req)}
                  onMouseOver={e => e.currentTarget.style.opacity="0.7"}
                  onMouseOut={e => e.currentTarget.style.opacity="0.5"}>
                  <span className="id-priority normal">Resolved</span>
                  <div style={{flex:1}}>
                    <div style={{fontSize:11, color:"#888880", marginBottom:3, textDecoration:"line-through"}}>{req.subject}</div>
                    <div style={{fontSize:9, color:"#999990"}}>{req.date} {req.system ? `· ${req.system}` : ""}</div>
                  </div>
                  <Icon path={icons.chevron} size={13} stroke="#D4D1CE"/>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* RIGHT COLUMN */}
        <div>
          {/* Client Info */}
          <div className="id-detail-card">
            <div className="id-card-header"><span className="id-card-title">Client Info</span></div>
            <div className="id-card-body">
              <div className="id-info-row"><span className="id-info-label">Phone</span><span className="id-info-value">{client.phone || "—"}</span></div>
              <div className="id-info-row"><span className="id-info-label">Email</span><span className="id-info-value">{client.email || "—"}</span></div>
              <div className="id-info-row"><span className="id-info-label">Install</span><span className="id-info-value">{client.installDate || "—"}</span></div>
              <div className="id-info-row" style={{marginBottom:0}}><span className="id-info-label">Portal</span><span className="id-info-value" style={{fontSize:9, wordBreak:"break-all"}}>{client.portalLink}</span></div>
            </div>
          </div>





          {/* Installer Notes */}
          <div className="id-detail-card">
            <div className="id-card-header">
              <span className="id-card-title">Installer Notes</span>
              <button className="id-btn ghost small" onClick={() => setEditingNotes(!editingNotes)}>
                {editingNotes ? "Cancel" : <><Icon path={icons.edit} size={11}/> Edit</>}
              </button>
            </div>
            <div className="id-card-body">
              {editingNotes ? (
                <>
                  <textarea className="id-notes-area" value={notes} onChange={e => setNotes(e.target.value)} placeholder="Add notes visible only to your team..."/>
                  <button className="id-btn" style={{marginTop:10, width:"100%", justifyContent:"center"}} onClick={saveNotes}>Save Notes</button>
                </>
              ) : (
                <div style={{fontSize:11, color: notes ? "#555550" : "#D4D1CE", lineHeight:1.7}}>
                  {notes || "No notes yet. Click Edit to add installer notes."}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>}

      {activeTab === 'portal' && (
        <div>
          {/* NETWORK INFO */}
          <div className="id-detail-card" style={{marginBottom:16}}>
            <div className="id-card-header">
              <span className="id-card-title">📶 Network / WiFi</span>
            </div>
            <div className="id-card-body">
              <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12}}>
                {[
                  ['ssid','WiFi Network Name (SSID)'],
                  ['wifi_password','WiFi Password'],
                  ['router_ip','Router IP Address'],
                  ['router_user','Router Username'],
                  ['router_password','Router Password'],
                ].map(([field, label]) => (
                  <div className="id-form-group" key={field} style={{margin:0}}>
                    <label className="id-form-label">{label}</label>
                    <input className="id-form-input" value={networkInfo[field]||''} onChange={e => setNetworkInfo(p => ({...p,[field]:e.target.value}))} placeholder="—"/>
                  </div>
                ))}
                <div className="id-form-group" style={{margin:0,gridColumn:'1/-1'}}>
                  <label className="id-form-label">Notes</label>
                  <input className="id-form-input" value={networkInfo.notes||''} onChange={e => setNetworkInfo(p => ({...p,notes:e.target.value}))} placeholder="e.g. Guest network: SmartTech_Guest"/>
                </div>
              </div>
              <button className="id-btn" style={{marginTop:16}} onClick={saveNetwork}>
                {savingNetwork ? 'Saving...' : 'Save Network Info'}
              </button>
            </div>
          </div>

          {/* DEVICES */}
          <div className="id-detail-card" style={{marginBottom:16}}>
            <div className="id-card-header">
              <span className="id-card-title">📱 Devices</span>
              <div style={{display:'flex',gap:8,alignItems:'center'}}>
                <label
                  onDragOver={e => { e.preventDefault(); e.currentTarget.style.background='#DDD9D4'; }}
                  onDragLeave={e => { e.currentTarget.style.background='transparent'; }}
                  onDrop={e => { e.preventDefault(); e.currentTarget.style.background='transparent'; const file = e.dataTransfer.files[0]; if (file) handleProposalPdf(file); }}
                  style={{display:'inline-flex',alignItems:'center',gap:4,fontSize:9,padding:'4px 10px',border:'1px dashed #D4D1CE',borderRadius:2,color:'#555550',letterSpacing:'0.06em',textTransform:'uppercase',cursor:'pointer',transition:'background 0.2s'}}
                  title="Drop a proposal PDF to auto-add all devices">
                  {proposalUploading ? '⏳ Reading...' : proposalExtracting ? '⏳ Extracting...' : '↑ Drop Proposal PDF'}
                  <input type="file" accept=".pdf" style={{display:'none'}} onChange={e => { if(e.target.files[0]) handleProposalPdf(e.target.files[0]); }} disabled={proposalUploading || proposalExtracting}/>
                </label>
                <button className="id-btn ghost small" onClick={async () => {
                  const { data } = await supabase.from('equipment_library').select('*').order('category,make,model');
                  if (data) setEquipmentLibrary(data);
                  setDeviceForm({ make: '', model: '', category: '', notes: '' });
                  setManualUrl('');
                  setShowAddDevice(true);
                }}>
                  <Icon path={icons.plus} size={11}/> Add Device
                </button>
              </div>
            </div>
            <div style={{padding:'0 20px'}}>
              {devices.length === 0 && <div className="id-empty">No devices added yet</div>}
              {['Networking','Audio','Video','Lighting','Security','Access Control','Climate','Other'].map(cat => {
                const catDevices = devices.filter(d => d.category === cat);
                if (catDevices.length === 0) return null;
                return (
                  <div key={cat} style={{marginBottom:12}}>
                    <div style={{fontSize:9,color:'#888880',textTransform:'uppercase',letterSpacing:'0.1em',marginBottom:6,paddingTop:8,borderTop:'1px solid #DDD9D4'}}>{cat}</div>
                    {catDevices.map(device => (
                      <div key={device.id} style={{display:'flex',alignItems:'center',gap:12,padding:'8px 0',borderBottom:'1px solid #DDD9D4'}}>
                        <div style={{flex:1}}>
                          <div style={{fontSize:11,fontWeight:600,color:'#555550'}}>{device.make} {device.model}</div>
                          {device.notes && <div style={{fontSize:9,color:'#888880',marginTop:2}}>{device.notes}</div>}
                        </div>
                        {device.manual_url && <a href={device.manual_url} target="_blank" rel="noreferrer" style={{fontSize:9,color:'#E50000',textDecoration:'none'}}>Manual</a>}
                        <button onClick={() => deleteDevice(device.id)} style={{background:'none',border:'none',color:'#D4D1CE',cursor:'pointer',fontSize:16,lineHeight:1}}
                          onMouseOver={e=>e.target.style.color='#E50000'} onMouseOut={e=>e.target.style.color='#D4D1CE'}>×</button>
                      </div>
                    ))}
                  </div>
                );
              })}
              {devices.length > 0 && devices.filter(d=>!d.category).map(device => (
                <div key={device.id} style={{display:'flex',alignItems:'center',gap:12,padding:'8px 0',borderBottom:'1px solid #DDD9D4'}}>
                  <div style={{flex:1}}>
                    <div style={{fontSize:11,fontWeight:600,color:'#555550'}}>{device.make} {device.model}</div>
                  </div>
                  {device.manual_url && <a href={device.manual_url} target="_blank" rel="noreferrer" style={{fontSize:9,color:'#E50000',textDecoration:'none'}}>Manual</a>}
                  <button onClick={() => deleteDevice(device.id)} style={{background:'none',border:'none',color:'#D4D1CE',cursor:'pointer',fontSize:16,lineHeight:1}}
                    onMouseOver={e=>e.target.style.color='#E50000'} onMouseOut={e=>e.target.style.color='#D4D1CE'}>×</button>
                </div>
              ))}
            </div>
          </div>

          {/* DOCUMENTS */}
          <div className="id-detail-card">
            <div className="id-card-header">
              <span className="id-card-title">📄 Documents</span>
              <div style={{display:'flex',gap:6}}>
                <button className="id-btn ghost small" onClick={() => setShowAddUrl(true)}>+ URL</button>
                <label style={{cursor:'pointer'}}>
                  <input type="file" accept=".pdf,.doc,.docx,.png,.jpg" style={{display:'none'}} onChange={uploadDocument}/>
                  <span className="id-btn ghost small" style={{display:'inline-flex',alignItems:'center',gap:4,fontSize:9,padding:'4px 10px',border:'1px solid #D4D1CE',borderRadius:2,color:'#555550',letterSpacing:'0.06em',textTransform:'uppercase',cursor:'pointer'}}>
                    {uploadingDoc ? 'Uploading...' : '+ Upload'}
                  </span>
                </label>
              </div>
            </div>
            <div style={{padding:'0 20px'}}>
              {documents.length === 0 && devices.filter(d=>d.manual_url).length === 0 && <div className="id-empty">No documents yet</div>}
              {devices.filter(d=>d.manual_url).map(d => (
                <div key={d.id} style={{display:'flex',alignItems:'center',gap:12,padding:'10px 0',borderBottom:'1px solid #DDD9D4'}}>
                  <div style={{background:'#1a3a2a',color:'#22c55e',fontSize:8,fontWeight:700,padding:'3px 6px',borderRadius:2,minWidth:36,textAlign:'center',letterSpacing:'0.06em'}}>MAN</div>
                  <div style={{flex:1}}>
                    <div style={{fontSize:11,color:'#555550',fontWeight:500}}>{d.make} {d.model} — Manual</div>
                  </div>
                  <a href={d.manual_url} target="_blank" rel="noreferrer" style={{fontSize:9,color:'#E50000',textDecoration:'none'}}>View</a>
                </div>
              ))}
              {documents.map(doc => (
                <div key={doc.id} style={{display:'flex',alignItems:'center',gap:12,padding:'10px 0',borderBottom:'1px solid #DDD9D4'}}>
                  <div style={{background:'#EEEBE7',color:'#E50000',fontSize:8,fontWeight:700,padding:'3px 6px',borderRadius:2,minWidth:36,textAlign:'center',letterSpacing:'0.06em',border:'1px solid #D4D1CE'}}>
                    {doc.category==='Network'?'NET':doc.category==='Warranty'?'WAR':doc.category==='Installation'?'INST':'PDF'}
                  </div>
                  <div style={{flex:1}}>
                    <div style={{fontSize:11,color:'#555550',fontWeight:500}}>{doc.name}</div>
                    <div style={{fontSize:9,color:'#999990',marginTop:1}}>{doc.category}</div>
                  </div>
                  <div style={{display:'flex',gap:8,alignItems:'center'}}>
                    <a href={doc.url} target="_blank" rel="noreferrer" style={{fontSize:9,color:'#E50000',textDecoration:'none'}}>View</a>
                    <button onClick={() => deleteDocument(doc.id)} style={{background:'none',border:'none',color:'#D4D1CE',cursor:'pointer',fontSize:16,lineHeight:1}}
                      onMouseOver={e=>e.target.style.color='#E50000'} onMouseOut={e=>e.target.style.color='#D4D1CE'}>×</button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Service Request Modal */}
      {selectedRequest && (
        <ServiceRequestModal
          request={selectedRequest}
          clientName={client.name}
          clientPhone={client.phone}
          onClose={() => setSelectedRequest(null)}
          onResolve={(reqId) => { resolveRequest(reqId); setSelectedRequest(null); }}
          onUpdate={(reqId, changes) => {
            const updated = { ...client, serviceRequests: client.serviceRequests.map(r => r.id === reqId ? { ...r, ...changes } : r) };
            onUpdate(updated);
            setSelectedRequest(prev => ({ ...prev, ...changes }));
          }}
        />
      )}

      {/* Add URL Document Modal */}
      {showAddUrl && (
        <div className="id-modal-overlay" onClick={() => setShowAddUrl(false)}>
          <div className="id-modal" onClick={e => e.stopPropagation()}>
            <button className="id-modal-close" onClick={() => setShowAddUrl(false)}><Icon path={icons.close} size={16}/></button>
            <div className="id-modal-eyebrow">Add Document</div>
            <div className="id-modal-title">Link a Document</div>
            <div className="id-form-group">
              <label className="id-form-label">Document Name</label>
              <input className="id-form-input" placeholder="e.g. Wi-Fi Network Credentials" value={urlForm.name} onChange={e => setUrlForm(p => ({...p, name: e.target.value}))}/>
            </div>
            <div className="id-form-group">
              <label className="id-form-label">Category</label>
              <select className="id-form-input" value={urlForm.category} onChange={e => setUrlForm(p => ({...p, category: e.target.value}))}>
                <option>General</option>
                <option>Network</option>
                <option>Warranty</option>
                <option>Manual</option>
                <option>Installation</option>
              </select>
            </div>
            <div className="id-form-group">
              <label className="id-form-label">URL</label>
              <input className="id-form-input" placeholder="https://..." value={urlForm.url} onChange={e => setUrlForm(p => ({...p, url: e.target.value}))}/>
            </div>
            <div className="id-modal-actions">
              <button className="id-btn ghost" onClick={() => setShowAddUrl(false)}>Cancel</button>
              <button className="id-btn" onClick={addUrlDocument}>Add Document</button>
            </div>
          </div>
        </div>
      )}

      {/* Add Device Modal */}
      {showAddDevice && (
        <div className="id-modal-overlay" onClick={() => setShowAddDevice(false)}>
          <div className="id-modal" onClick={e => e.stopPropagation()}>
            <button className="id-modal-close" onClick={() => setShowAddDevice(false)}><Icon path={icons.close} size={16}/></button>
            <div className="id-modal-eyebrow">Add Device</div>
            <div className="id-modal-title">Device Details</div>
            <div className="id-form-group">
              <label className="id-form-label">Category</label>
              <select className="id-form-input" value={deviceForm.category} onChange={e => handleCategoryChange(e.target.value)}>
                <option value="">Select category...</option>
                {libCategories.length > 0
                  ? libCategories.map(cat => <option key={cat}>{cat}</option>)
                  : ['Network','Audio','Video','Lighting','Security','Access Control','Climate','Other'].map(cat => <option key={cat}>{cat}</option>)
                }
              </select>
            </div>
            <div className="id-form-group">
              <label className="id-form-label">Make</label>
              {libMakes.length > 0 ? (
                <>
                  <select className="id-form-input" value={deviceForm.make} onChange={e => handleMakeChange(e.target.value)}>
                    <option value="">Select make...</option>
                    {libMakes.map(m => <option key={m}>{m}</option>)}
                    <option value="__other__">Other (type manually)</option>
                  </select>
                  {deviceForm.make === '__other__' && (
                    <input className="id-form-input" style={{marginTop:6}} placeholder="Type make..."
                      onChange={e => setDeviceForm(p => ({...p, make: e.target.value, model: ''}))}/>
                  )}
                </>
              ) : (
                <input className="id-form-input" placeholder="e.g. Araknis" value={deviceForm.make} onChange={e => setDeviceForm(p => ({...p, make: e.target.value, model: ''}))}/>
              )}
            </div>
            <div className="id-form-group">
              <label className="id-form-label">Model</label>
              {libModels.length > 0 ? (
                <>
                  <select className="id-form-input" value={deviceForm.model} onChange={e => handleModelChange(e.target.value)}>
                    <option value="">Select model...</option>
                    {libModels.map(m => <option key={m}>{m}</option>)}
                    <option value="__other__">Other (type manually)</option>
                  </select>
                  {deviceForm.model === '__other__' && (
                    <input className="id-form-input" style={{marginTop:6}} placeholder="Type model..."
                      onChange={e => setDeviceForm(p => ({...p, model: e.target.value}))}/>
                  )}
                </>
              ) : (
                <input className="id-form-input" placeholder="e.g. AN-310-RT" value={deviceForm.model} onChange={e => setDeviceForm(p => ({...p, model: e.target.value}))}/>
              )}
            </div>
            <div className="id-form-group">
              <label className="id-form-label">Manual URL</label>
              <div style={{display:'flex',gap:8}}>
                <input className="id-form-input" placeholder="Auto-filled from library, or paste URL" value={manualUrl} onChange={e => setManualUrl(e.target.value)} style={{flex:1}}/>
                <button className="id-btn ghost small" onClick={() => {
                  if (deviceForm.make && deviceForm.model) {
                    const url = `https://www.manualslib.com/search/?q=${encodeURIComponent(deviceForm.make + ' ' + deviceForm.model)}`;
                    window.open(url, '_blank');
                  }
                }}>Search</button>
              </div>
              {manualUrl
                ? <div style={{fontSize:9,color:'#E50000',marginTop:4}}>✓ Manual auto-filled from equipment library</div>
                : <div style={{fontSize:9,color:'#999990',marginTop:4}}>Select a model from the library to auto-fill, or click Search to find manually</div>
              }
            </div>
            <div className="id-form-group">
              <label className="id-form-label">Notes (optional)</label>
              <input className="id-form-input" placeholder="e.g. Living room, serial #12345" value={deviceForm.notes} onChange={e => setDeviceForm(p => ({...p, notes: e.target.value}))}/>
            </div>
            <div className="id-modal-actions">
              <button className="id-btn ghost" onClick={() => setShowAddDevice(false)}>Cancel</button>
              <button className="id-btn" onClick={saveDevice}>Save Device</button>
            </div>
          </div>
        </div>
      )}

      {/* Edit Modal */}
      {editing && (
        <div className="id-modal-overlay" onClick={() => setEditing(false)}>
          <div className="id-modal" onClick={e => e.stopPropagation()}>
            <div className="id-form-group">
              <label className="id-form-label">Systems</label>
              <div className="id-systems-grid">
                {ALL_SYSTEMS.map(sys => (
                  <button key={sys.id} className={`id-system-toggle ${editForm.systems.includes(sys.id) ? "selected" : ""}`} onClick={() => toggleEditSystem(sys.id)}>
                    <div className="id-system-check">
                      {editForm.systems.includes(sys.id) && <Icon path={icons.check} size={9} stroke="#fff" strokeWidth={3}/>}
                    </div>
                    {sys.name}
                  </button>
                ))}
                {customEditSystems.map((val, i) => (
                  <div key={`cedit-${i}`}
                    className={`id-system-toggle ${val && editForm.systems.includes(`cedit-${i}`) ? "selected" : ""}`}
                    style={{cursor: val ? "pointer" : "default"}}
                    onClick={() => val && toggleEditSystem(`cedit-${i}`)}>
                    <div className="id-system-check">
                      {val && editForm.systems.includes(`cedit-${i}`) && <Icon path={icons.check} size={9} stroke="#fff" strokeWidth={3}/>}
                    </div>
                    <input
                      className="id-form-input"
                      placeholder="Add system..."
                      value={val}
                      onClick={e => e.stopPropagation()}
                      onChange={e => updateCustomEdit(i, e.target.value)}
                      style={{background:"transparent", border:"none", padding:0, width:"100%", color: val ? "#111111" : "#888880", cursor:"text"}}
                    />
                  </div>
                ))}
              </div>
            </div>
            <button className="id-modal-close" onClick={() => setEditing(false)}><Icon path={icons.close} size={16}/></button>
            <div className="id-modal-eyebrow">Edit Client</div>
            <div className="id-modal-title">Update Details</div>
            {["name","systemName","address","phone","email","installDate"].map(field => (
              <div className="id-form-group" key={field}>
                <label className="id-form-label">{field === "installDate" ? "Install Date" : field === "systemName" ? "System Name" : field.charAt(0).toUpperCase() + field.slice(1)}</label>
                <input className="id-form-input" type={field === "installDate" ? "date" : field === "email" ? "email" : "text"} value={editForm[field]} onChange={e => setEditForm(p => ({...p, [field]: e.target.value}))}/>
                {field === "email" && editForm.email !== client.email && (
                  <div style={{fontSize:9,color:'#E50000',marginTop:4,letterSpacing:'0.06em'}}>⚠ Email changed — invite will be reset. Send a new invite after saving.</div>
                )}
              </div>
            ))}
            <div className="id-modal-actions">
              <button className="id-btn ghost" onClick={() => setEditing(false)}>Cancel</button>
              <button className="id-btn" onClick={saveEdit}>Save Changes</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ── MAIN DASHBOARD VIEW ──────────────────────────────────────────────────────

// ── LIBRARY VIEW ─────────────────────────────────────────────────────────────

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
const ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY;

function LibraryView({ onClose, onToast }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [uploading, setUploading] = useState(false);
  const [extracting, setExtracting] = useState(false);
  const [search, setSearch] = useState('');
  const [filterCat, setFilterCat] = useState('All');
  const [editItem, setEditItem] = useState(null);
  const [confirmDelete, setConfirmDelete] = useState(null);

  useEffect(() => { loadLibrary(); }, []);

  const loadLibrary = async () => {
    setLoading(true);
    const { data } = await supabase.from('equipment_library').select('*').order('category,make,model');
    if (data) setItems(data);
    setLoading(false);
  };

  const handlePdfFromFile = (file) => {
    if (!file || file.type !== 'application/pdf') return;
    handlePdfUpload({ target: { files: [file] } });
  };
  const handlePdfUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setUploading(true);
    onToast('Reading PDF...');
    // Extract text from PDF client-side
    const arrayBuffer = await file.arrayBuffer();
    const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;
    let pdfText = '';
    for (let i = 1; i <= pdf.numPages; i++) {
      const page = await pdf.getPage(i);
      const tc = await page.getTextContent();
      pdfText += tc.items.map(item => item.str).join(' ') + '\n';
    }
    setUploading(false);
    setExtracting(true);
    onToast('Extracting equipment with AI...');
    try {
      const response = await fetch('/.netlify/functions/extract-equipment', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ pdfText: pdfText.substring(0, 25000), model: 'claude-sonnet-4-5', max_tokens: 4000 })
      });
      const data = await response.json();
      const text = data.content?.[0]?.text || '[]';
      console.log('AI response:', text.substring(0, 200));
      let extracted = [];
      try {
        const cleanText = text.replace(/^```json\s*/m, "").replace(/\s*```\s*$/m, "").trim();
        extracted = JSON.parse(cleanText);
      } catch(e) {
        onToast('Parse error: ' + text.substring(0, 100));
        setExtracting(false);
        return;
      }
      if (!Array.isArray(extracted) || extracted.length === 0) {
        onToast('No equipment with make/model found in PDF');
        setExtracting(false);
        return;
      }
      onToast(`Found ${extracted.length} items, searching for manuals...`);
      const searchManualUrl = async (make, deviceModel) => {
        try {
          const res = await fetch('/.netlify/functions/extract-equipment', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              manualSearch: true,
              make,
              deviceModel,
            })
          });
          const d = await res.json();
          const url = (d.content?.[0]?.text || '').trim();
          if (url && url !== 'NONE' && url.startsWith('http')) return url;
        } catch(e) {}
        return '';
      };
      const items = await loadLibrary() || [];
      let added = 0, skipped = 0;
      for (const item of extracted) {
        const exists = items.some(i =>
          i.make?.toLowerCase() === item.make?.toLowerCase() &&
          i.model?.toLowerCase() === item.model?.toLowerCase()
        );
        if (!exists) {
          const manualUrl = await searchManualUrl(item.make, item.model);
          await supabase.from('equipment_library').insert([{
            make: item.make,
            model: item.model,
            category: item.category || 'Other',
            description: item.description || '',
            manual_url: manualUrl,
          }]);
          added++;
        } else {
          skipped++;
        }
      }
      await loadLibrary();
      onToast('Added ' + added + ' items' + (skipped > 0 ? ', skipped ' + skipped + ' duplicates' : ''));
    } catch(err) {
      onToast('Error: ' + err.message);
    }
    setExtracting(false);
    e.target.value = '';
  };

  const handleSaveEdit = async () => {
    if (!editItem.make || !editItem.model) return;
    if (editItem.id) {
      await supabase.from('equipment_library').update({
        make: editItem.make,
        model: editItem.model,
        category: editItem.category,
        description: editItem.description,
        manual_url: editItem.manual_url,
      }).eq('id', editItem.id);
    } else {
      await supabase.from('equipment_library').insert([{
        make: editItem.make,
        model: editItem.model,
        category: editItem.category || 'Other',
        description: editItem.description || '',
        manual_url: editItem.manual_url || '',
      }]);
    }
    await loadLibrary();
    setEditItem(null);
    onToast(editItem.id ? 'Item updated' : 'Item added');
  };

  const handleDelete = async (id) => {
    await supabase.from('equipment_library').delete().eq('id', id);
    setItems(p => p.filter(i => i.id !== id));
    setConfirmDelete(null);
    onToast('Item removed from library');
  };

  const CATEGORIES = ['All', 'Audio', 'Video', 'Lighting', 'Networking', 'Security', 'Control', 'Other'];
  const filtered = items.filter(i => {
    const matchCat = filterCat === 'All' || i.category === filterCat;
    const matchSearch = !search || 
      i.make?.toLowerCase().includes(search.toLowerCase()) || 
      i.model?.toLowerCase().includes(search.toLowerCase()) ||
      i.description?.toLowerCase().includes(search.toLowerCase());
    return matchCat && matchSearch;
  });

  const grouped = CATEGORIES.slice(1).reduce((acc, cat) => {
    const catItems = filtered.filter(i => i.category === cat);
    if (catItems.length > 0) acc[cat] = catItems;
    return acc;
  }, {});

  return (
    <div>
      {/* Header */}
      <div style={{display:'flex', alignItems:'flex-start', justifyContent:'space-between', marginBottom:28}}>
        <div>
          <div style={{fontSize:9, fontWeight:600, letterSpacing:'0.14em', textTransform:'uppercase', color:'#E50000', marginBottom:6}}>Master Library</div>
          <div style={{fontFamily:"'Cormorant Garamond', serif", fontSize:32, fontWeight:300, color:'#111111', lineHeight:1.1, marginBottom:6}}>Equipment Library</div>
          <div style={{fontSize:11, color:'#888880'}}>{items.length} items · Upload a proposal PDF to auto-extract equipment</div>
        </div>
        <div style={{display:'flex', gap:10}}>
          <button
            onClick={() => setEditItem({ make:'', model:'', category:'Other', description:'', manual_url:'' })}
            style={{background:'#EEEBE7', border:'1px solid #D4D1CE', color:'#111111', padding:'8px 16px', borderRadius:3, fontSize:10, fontWeight:600, letterSpacing:'0.1em', textTransform:'uppercase', cursor:'pointer'}}
          >+ Add Item</button>
          <label
            onDragOver={e => { e.preventDefault(); e.currentTarget.style.opacity='0.8'; }}
            onDragLeave={e => { e.currentTarget.style.opacity='1'; }}
            onDrop={e => { e.preventDefault(); e.currentTarget.style.opacity='1'; const file = e.dataTransfer.files[0]; if (file) handlePdfFromFile(file); }}
            style={{background:'#E50000', color:'#fff', padding:'8px 16px', borderRadius:3, fontSize:10, fontWeight:600, letterSpacing:'0.1em', textTransform:'uppercase', cursor:'pointer', display:'flex', alignItems:'center', gap:6, transition:'all 0.2s'}}>
            {uploading || extracting ? (extracting ? '⏳ Extracting...' : '⏳ Reading...') : '↑ Upload or Drop PDF'}
            <input type="file" accept=".pdf" style={{display:'none'}} onChange={handlePdfUpload} disabled={uploading || extracting}/>
          </label>
        </div>
      </div>

      {/* Search + Filter */}
      <div style={{display:'flex', gap:10, marginBottom:24, alignItems:'center'}}>
        <input
          placeholder="Search make, model, description..."
          value={search}
          onChange={e => setSearch(e.target.value)}
          style={{flex:1, background:'#FFFFFF', border:'1px solid #DDD9D4', borderRadius:3, padding:'8px 12px', color:'#111111', fontSize:11, fontFamily:"'Montserrat', sans-serif", outline:'none'}}
        />
        <div style={{display:'flex', gap:6}}>
          {CATEGORIES.map(cat => (
            <button key={cat} onClick={() => setFilterCat(cat)} style={{
              background: filterCat === cat ? '#E50000' : '#DDD9D4',
              border: '1px solid ' + (filterCat === cat ? '#E50000' : '#D4D1CE'),
              color: filterCat === cat ? '#fff' : '#777770',
              padding:'5px 10px', borderRadius:3, fontSize:9, fontWeight:600,
              letterSpacing:'0.1em', textTransform:'uppercase', cursor:'pointer'
            }}>{cat}</button>
          ))}
        </div>
      </div>

      {/* Items */}
      {loading ? (
        <div style={{color:'#999990', fontSize:12, padding:'40px 0', textAlign:'center'}}>Loading library...</div>
      ) : items.length === 0 ? (
        <div style={{color:'#999990', fontSize:12, padding:'60px 0', textAlign:'center', lineHeight:2}}>
          No equipment yet.<br/>Upload a proposal PDF to get started.
        </div>
      ) : filtered.length === 0 ? (
        <div style={{color:'#999990', fontSize:12, padding:'40px 0', textAlign:'center'}}>No results for "{search}"</div>
      ) : (
        Object.entries(grouped).map(([cat, catItems]) => (
          <div key={cat} style={{marginBottom:32}}>
            <div style={{fontSize:9, fontWeight:600, letterSpacing:'0.14em', textTransform:'uppercase', color:'#888880', marginBottom:12, paddingBottom:8, borderBottom:'1px solid #DDD9D4'}}>{cat} · {catItems.length}</div>
            <div style={{display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(280px, 1fr))', gap:10}}>
              {catItems.map(item => (
                <div key={item.id} style={{background:'#FFFFFF', border:'1px solid #DDD9D4', borderRadius:4, padding:'14px 16px', display:'flex', flexDirection:'column', gap:4, position:'relative', transition:'border-color 0.2s'}}
                  onMouseOver={e => e.currentTarget.style.borderColor='#D4D1CE'}
                  onMouseOut={e => e.currentTarget.style.borderColor='#DDD9D4'}
                >
                  <div style={{fontSize:10, color:'#777770', letterSpacing:'0.08em'}}>{item.make}</div>
                  <div style={{fontSize:13, fontWeight:600, color:'#111111'}}>{item.model}</div>
                  {item.description && <div style={{fontSize:10, color:'#888880', marginTop:2}}>{item.description}</div>}
                  {item.manual_url && (
                    <a href={item.manual_url} target="_blank" rel="noreferrer" style={{fontSize:9, color:'#E50000', textDecoration:'none', marginTop:4, letterSpacing:'0.08em'}}>↗ Manual</a>
                  )}
                  <div style={{display:'flex', gap:8, marginTop:8}}>
                    <button onClick={() => setEditItem({...item})} style={{background:'#EEEBE7', border:'1px solid #D4D1CE', color:'#555550', padding:'4px 10px', borderRadius:2, fontSize:9, cursor:'pointer', fontWeight:600, letterSpacing:'0.08em'}}>Edit</button>
                    <button onClick={() => setConfirmDelete(item)} style={{background:'none', border:'1px solid #D4D1CE', color:'#888880', padding:'4px 10px', borderRadius:2, fontSize:9, cursor:'pointer', fontWeight:600, letterSpacing:'0.08em'}}>Remove</button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))
      )}

      {/* Edit/Add Modal */}
      {editItem && (
        <div style={{position:'fixed', inset:0, background:'rgba(0,0,0,0.8)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:100}} onClick={() => setEditItem(null)}>
          <div style={{background:'#FFFFFF', border:'1px solid #D4D1CE', borderRadius:6, padding:28, width:420, maxWidth:'90vw'}} onClick={e => e.stopPropagation()}>
            <div style={{fontSize:9, color:'#E50000', fontWeight:600, letterSpacing:'0.14em', textTransform:'uppercase', marginBottom:6}}>{editItem.id ? 'Edit Item' : 'Add Item'}</div>
            <div style={{fontFamily:"'Cormorant Garamond', serif", fontSize:22, color:'#111111', marginBottom:20}}>{editItem.id ? `${editItem.make} ${editItem.model}` : 'New Equipment'}</div>
            {[
              ['Make / Brand', 'make', 'text', 'e.g. Sonos'],
              ['Model', 'model', 'text', 'e.g. Era 300'],
              ['Description', 'description', 'text', 'Brief description (optional)'],
              ['Manual URL', 'manual_url', 'text', 'https://...'],
            ].map(([label, key, type, placeholder]) => (
              <div key={key} style={{marginBottom:14}}>
                <label style={{fontSize:9, fontWeight:600, letterSpacing:'0.12em', textTransform:'uppercase', color:'#777770', display:'block', marginBottom:6}}>{label}</label>
                <input
                  type={type} placeholder={placeholder} value={editItem[key] || ''}
                  onChange={e => setEditItem(p => ({...p, [key]: e.target.value}))}
                  style={{width:'100%', background:'#F8F5F2', border:'1px solid #D4D1CE', borderRadius:3, padding:'8px 12px', color:'#111111', fontSize:11, fontFamily:"'Montserrat', sans-serif", outline:'none', boxSizing:'border-box'}}
                />
              </div>
            ))}
            <div style={{marginBottom:20}}>
              <label style={{fontSize:9, fontWeight:600, letterSpacing:'0.12em', textTransform:'uppercase', color:'#777770', display:'block', marginBottom:6}}>Category</label>
              <select value={editItem.category || 'Other'} onChange={e => setEditItem(p => ({...p, category: e.target.value}))}
                style={{width:'100%', background:'#F8F5F2', border:'1px solid #D4D1CE', borderRadius:3, padding:'8px 12px', color:'#111111', fontSize:11, fontFamily:"'Montserrat', sans-serif", outline:'none'}}>
                {['Audio','Video','Lighting','Networking','Security','Control','Other'].map(c => <option key={c} value={c}>{c}</option>)}
              </select>
            </div>
            <div style={{display:'flex', gap:10}}>
              <button onClick={handleSaveEdit} disabled={!editItem.make || !editItem.model}
                style={{flex:1, background:'#E50000', color:'#fff', border:'none', borderRadius:3, padding:'10px', fontSize:10, fontWeight:600, letterSpacing:'0.1em', textTransform:'uppercase', cursor:'pointer'}}>
                {editItem.id ? 'Save Changes' : 'Add to Library'}
              </button>
              <button onClick={() => setEditItem(null)}
                style={{background:'#EEEBE7', color:'#777770', border:'1px solid #D4D1CE', borderRadius:3, padding:'10px 16px', fontSize:10, cursor:'pointer'}}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Confirm Delete */}
      {confirmDelete && (
        <div style={{position:'fixed', inset:0, background:'rgba(0,0,0,0.8)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:100}} onClick={() => setConfirmDelete(null)}>
          <div style={{background:'#FFFFFF', border:'1px solid #D4D1CE', borderRadius:6, padding:28, width:360, textAlign:'center'}} onClick={e => e.stopPropagation()}>
            <div style={{fontSize:13, color:'#111111', marginBottom:8}}>Remove <strong>{confirmDelete.make} {confirmDelete.model}</strong>?</div>
            <div style={{fontSize:11, color:'#888880', marginBottom:20}}>This won't affect clients already assigned this item.</div>
            <div style={{display:'flex', gap:10, justifyContent:'center'}}>
              <button onClick={() => handleDelete(confirmDelete.id)} style={{background:'#E50000', color:'#fff', border:'none', borderRadius:3, padding:'8px 20px', fontSize:10, fontWeight:600, cursor:'pointer'}}>Remove</button>
              <button onClick={() => setConfirmDelete(null)} style={{background:'#EEEBE7', color:'#777770', border:'1px solid #D4D1CE', borderRadius:3, padding:'8px 16px', fontSize:10, cursor:'pointer'}}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function ManageInstallersView({ onToast }) {
  const [installers, setInstallers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAdd, setShowAdd] = useState(false);
  const [form, setForm] = useState({ name: '', email: '', password: '' });
  const [saving, setSaving] = useState(false);
  const [confirmDelete, setConfirmDelete] = useState(null);

  const loadInstallers = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${process.env.REACT_APP_SUPABASE_URL}/auth/v1/admin/users?per_page=200`, {
        headers: {
          'apikey': process.env.REACT_APP_SUPABASE_SERVICE_KEY,
          'Authorization': `Bearer ${process.env.REACT_APP_SUPABASE_SERVICE_KEY}`,
        }
      });
      const data = await res.json();
      const users = data.users || [];
      setInstallers(users.filter(u => u.user_metadata?.role === 'installer'));
    } catch(e) {
      onToast('Error loading installers');
    }
    setLoading(false);
  };

  useEffect(() => { loadInstallers(); }, []);

  const handleCreate = async () => {
    if (!form.email || !form.password || !form.name) return;
    setSaving(true);
    try {
      const res = await fetch(`${process.env.REACT_APP_SUPABASE_URL}/auth/v1/admin/users`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'apikey': process.env.REACT_APP_SUPABASE_SERVICE_KEY,
          'Authorization': `Bearer ${process.env.REACT_APP_SUPABASE_SERVICE_KEY}`,
        },
        body: JSON.stringify({
          email: form.email,
          password: form.password,
          email_confirm: true,
          user_metadata: { role: 'installer', name: form.name }
        })
      });
      const data = await res.json();
      if (data.id) {
        onToast(`Installer account created for ${form.name}`);
        setForm({ name: '', email: '', password: '' });
        setShowAdd(false);
        loadInstallers();
      } else {
        onToast('Error: ' + (data.msg || data.message || 'Unknown error'));
      }
    } catch(e) {
      onToast('Error creating installer');
    }
    setSaving(false);
  };

  const handleDelete = async (installer) => {
    try {
      await fetch(`${process.env.REACT_APP_SUPABASE_URL}/auth/v1/admin/users/${installer.id}`, {
        method: 'DELETE',
        headers: {
          'apikey': process.env.REACT_APP_SUPABASE_SERVICE_KEY,
          'Authorization': `Bearer ${process.env.REACT_APP_SUPABASE_SERVICE_KEY}`,
        }
      });
      onToast(`${installer.user_metadata?.name || installer.email} removed`);
      setConfirmDelete(null);
      loadInstallers();
    } catch(e) {
      onToast('Error removing installer');
    }
  };

  return (
    <div>
      <div style={{display:'flex',alignItems:'flex-start',justifyContent:'space-between',marginBottom:24,flexWrap:'wrap',gap:12}}>
        <div>
          <div style={{fontSize:9,color:'#E50000',fontWeight:600,letterSpacing:'0.14em',textTransform:'uppercase',marginBottom:4}}>Admin Only</div>
          <div style={{fontFamily:"'Cormorant Garamond', serif",fontSize:32,fontWeight:300,color:'#111111',lineHeight:1.1,marginBottom:4}}>Manage Installers</div>
          <div style={{fontSize:11,color:'#888880'}}>{installers.length} installer account{installers.length !== 1 ? 's' : ''}</div>
        </div>
        <button onClick={() => setShowAdd(true)}
          style={{background:'#E50000',color:'#fff',border:'none',borderRadius:3,padding:'10px 20px',fontSize:10,fontWeight:700,letterSpacing:'0.1em',textTransform:'uppercase',cursor:'pointer'}}>
          + Add Installer
        </button>
      </div>

      {loading && <div style={{color:'#888880',fontSize:12,letterSpacing:'0.1em'}}>Loading...</div>}

      {!loading && installers.length === 0 && (
        <div style={{color:'#888880',fontSize:13,padding:'40px 0',textAlign:'center'}}>No installer accounts yet. Add one above.</div>
      )}

      <div style={{display:'flex',flexDirection:'column',gap:8}}>
        {installers.map(installer => (
          <div key={installer.id} style={{background:'#FFFFFF',border:'1px solid #1e1e1e',borderRadius:2,padding:'16px 20px',display:'flex',alignItems:'center',justifyContent:'space-between',gap:12}}>
            <div>
              <div style={{fontSize:13,color:'#111111',marginBottom:4}}>{installer.user_metadata?.name || '—'}</div>
              <div style={{fontSize:11,color:'#888880',letterSpacing:'0.06em'}}>{installer.email}</div>
              <div style={{fontSize:9,color:'#999990',marginTop:4,letterSpacing:'0.06em'}}>Created {new Date(installer.created_at).toLocaleDateString()}</div>
            </div>
            <button onClick={() => setConfirmDelete(installer)}
              style={{background:'transparent',border:'1px solid #D4D1CE',color:'#888880',borderRadius:2,padding:'6px 14px',fontSize:9,fontWeight:700,letterSpacing:'0.08em',textTransform:'uppercase',cursor:'pointer'}}>
              Remove
            </button>
          </div>
        ))}
      </div>

      {/* Add Installer Modal */}
      {showAdd && (
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.8)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:200}} onClick={() => setShowAdd(false)}>
          <div style={{background:'#FFFFFF',border:'1px solid #D4D1CE',borderRadius:6,padding:32,width:400,maxWidth:'90vw'}} onClick={e => e.stopPropagation()}>
            <div style={{fontSize:9,color:'#E50000',fontWeight:600,letterSpacing:'0.14em',textTransform:'uppercase',marginBottom:4}}>New Account</div>
            <div style={{fontFamily:"'Cormorant Garamond', serif",fontSize:24,color:'#111111',marginBottom:24}}>Add Installer</div>
            {[['Name','name','text','Full name'],['Email','email','email','installer@email.com'],['Password','password','password','Temporary password']].map(([label,key,type,placeholder]) => (
              <div key={key} style={{marginBottom:16}}>
                <div style={{fontSize:9,fontWeight:600,letterSpacing:'0.12em',textTransform:'uppercase',color:'#777770',marginBottom:6}}>{label}</div>
                <input type={type} placeholder={placeholder} value={form[key]}
                  onChange={e => setForm(p => ({...p, [key]: e.target.value}))}
                  style={{width:'100%',boxSizing:'border-box',background:'#EEEBE7',border:'1px solid #D4D1CE',borderRadius:3,padding:'10px 12px',color:'#111111',fontSize:12,outline:'none'}}/>
              </div>
            ))}
            <div style={{fontSize:9,color:'#888880',marginBottom:20}}>The installer will use these credentials to log in. They will have limited access — no delete or invite permissions.</div>
            <div style={{display:'flex',gap:10}}>
              <button onClick={handleCreate} disabled={saving || !form.email || !form.password || !form.name}
                style={{flex:1,background:'#E50000',color:'#fff',border:'none',borderRadius:3,padding:'12px',fontSize:11,fontWeight:700,letterSpacing:'0.1em',textTransform:'uppercase',cursor:'pointer',opacity:saving?0.6:1}}>
                {saving ? 'Creating...' : 'Create Account'}
              </button>
              <button onClick={() => setShowAdd(false)}
                style={{background:'#EEEBE7',color:'#777770',border:'1px solid #D4D1CE',borderRadius:3,padding:'12px 20px',fontSize:11,cursor:'pointer'}}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Confirm Remove Modal */}
      {confirmDelete && (
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.8)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:200}} onClick={() => setConfirmDelete(null)}>
          <div style={{background:'#FFFFFF',border:'1px solid #D4D1CE',borderRadius:6,padding:28,width:340,textAlign:'center'}} onClick={e => e.stopPropagation()}>
            <div style={{fontSize:14,color:'#111111',marginBottom:8}}>Remove installer account?</div>
            <div style={{fontSize:12,color:'#888880',marginBottom:4}}>{confirmDelete.user_metadata?.name}</div>
            <div style={{fontSize:11,color:'#999990',marginBottom:24}}>{confirmDelete.email}</div>
            <div style={{display:'flex',gap:10,justifyContent:'center'}}>
              <button onClick={() => handleDelete(confirmDelete)}
                style={{background:'#E50000',color:'#fff',border:'none',borderRadius:3,padding:'8px 24px',fontSize:10,fontWeight:700,cursor:'pointer'}}>
                Remove
              </button>
              <button onClick={() => setConfirmDelete(null)}
                style={{background:'#EEEBE7',color:'#777770',border:'1px solid #D4D1CE',borderRadius:3,padding:'8px 16px',fontSize:10,cursor:'pointer'}}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function DashboardView({ clients, onSelectClient, onNewClient, onSelectRequest, isInstaller }) {
  const totalClients = clients.length;
  const credPending = clients.filter(c => credProgress(c).pct < 100).length;
  const allRequests = clients.flatMap(c => c.serviceRequests.map(r => ({...r, clientName: c.name})));
  const openRequests = allRequests.filter(r => !r.resolved);
  const recentCreds = clients.flatMap(c =>
    c.systems.filter(s => c.credentials[s]).map(s => ({
      client: c.name,
      system: ALL_SYSTEMS.find(a => a.id === s)?.name,
    }))
  ).slice(-5).reverse();

  return (
    <div>
      <div style={{display:"flex", alignItems:"flex-start", justifyContent:"space-between", marginBottom:28, flexWrap:"wrap", gap:14}}>
        <div className="id-page-header" style={{marginBottom:0}}>
          <div className="id-page-eyebrow">Smart Tech Utah</div>
          <div className="id-page-title">Installer Dashboard</div>
        </div>
        {!isInstaller && (
        <button className="id-btn" onClick={onNewClient}>
          <Icon path={icons.plus} size={14}/> New Client
        </button>
        )}
      </div>

      {/* Stats */}
      <div className="id-stats">
        <div className="id-stat">
          <div className="id-stat-value">{totalClients}</div>
          <div className="id-stat-label">Total Clients</div>
        </div>
        <div className="id-stat">
          <div className="id-stat-value red">{credPending}</div>
          <div className="id-stat-label">Credentials Pending</div>
        </div>
        <div className="id-stat">
          <div className="id-stat-value red">{openRequests.length}</div>
          <div className="id-stat-label">Open Requests</div>
        </div>
        <div className="id-stat">
          <div className="id-stat-value">{clients.filter(c => credProgress(c).pct === 100).length}</div>
          <div className="id-stat-label">Fully Complete</div>
        </div>
      </div>

      {/* Grid */}
      <div className="id-grid">
        {/* Client List */}
        <div className="id-section">
          <div className="id-section-header">
            <span className="id-section-title">All Clients</span>
            <span style={{fontSize:10, color:"#999990"}}>{totalClients} total</span>
          </div>
          {clients.length === 0 && <div className="id-empty">No clients yet. Create your first client above.</div>}
          {clients.map(client => {
            const { done, total, pct } = credProgress(client);
            const hasUnread = (client.serviceRequests || []).some(r => !r.resolved && (r.thread || []).some(m => m.from === "client") && (!r.lastReadInstaller));
            return (
              <div key={client.id} className="id-client-row" onClick={() => onSelectClient(client)}>
                <div style={{position:"relative", display:"inline-block"}}>
                  <div className="id-client-avatar">{initials(client.name)}</div>
                  {hasUnread && <div style={{position:"absolute", top:0, right:0, width:9, height:9, borderRadius:"50%", background:"#E50000", border:"2px solid #F8F5F2"}}/>
                  }</div>
                <div className="id-client-info">
                  <div className="id-client-name">{client.name}</div>
                  <div className="id-client-address">{client.address}</div>
                  <div style={{marginTop:4}}>{inviteBadge(client.inviteStatus || 'not-sent')}</div>
                </div>
                <div className="id-client-progress">
                  <div className="id-progress-bar">
                    <div className="id-progress-fill" style={{width:`${pct}%`, background: pct===100?"#22c55e":"#E50000"}}/>
                  </div>
                  <div className="id-progress-text">{done}/{total} creds</div>
                </div>
                <div className="id-chevron"><Icon path={icons.chevron} size={14}/></div>
              </div>
            );
          })}
        </div>

        {/* Right Panels */}
        <div>
          {/* Pending Requests */}
          <div className="id-section" style={{marginBottom:16}}>
            <div className="id-section-header">
              <span className="id-section-title">Open Service Requests</span>
              {openRequests.length > 0 && <span style={{fontSize:10, color:"#E50000", fontWeight:700}}>{openRequests.length}</span>}
            </div>
            {openRequests.length === 0 && <div className="id-empty">No open requests</div>}
            {openRequests.map(req => (
              <div key={req.id} className="id-panel-item" style={{cursor:"pointer", transition:"background 0.15s"}}
                onClick={() => onSelectRequest(req)}
                onMouseOver={e => e.currentTarget.style.background="rgba(0,0,0,0.03)"}
                onMouseOut={e => e.currentTarget.style.background="transparent"}>
                <div className="id-panel-dot"/>
                <div style={{flex:1}}>
                  <div className="id-panel-subject">{req.subject}</div>
                  <div className="id-panel-meta">{req.clientName} · {req.priority} · {req.date}</div>
                </div>
                <Icon path={icons.chevron} size={12} stroke="#D4D1CE"/>
              </div>
            ))}
          </div>

          {/* Recent Credentials */}
          <div className="id-section">
            <div className="id-section-header">
              <span className="id-section-title">Recent Submissions</span>
            </div>
            {recentCreds.length === 0 && <div className="id-empty">No credentials submitted yet</div>}
            {recentCreds.map((c, i) => (
              <div key={i} className="id-panel-item">
                <div className="id-panel-dot green"/>
                <div>
                  <div className="id-panel-subject">{c.system} credentials received</div>
                  <div className="id-panel-meta">{c.client}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

// ── APP ──────────────────────────────────────────────────────────────────────
function PinUnlockScreen({ onUnlock, onSignOut }) {
  const [pin, setPin] = useState('');
  const [pinError, setPinError] = useState('');
  const [loading, setLoading] = useState(false);
  const savedPin = getPin();

  const handlePinCheck = async (p) => {
    if (p.length !== 4) return;
    setLoading(true);
    const hash = await hashPin(p, savedPin.email);
    if (hash === savedPin.hash) {
      onUnlock();
    } else {
      setPinError('Incorrect PIN');
      setPin('');
    }
    setLoading(false);
  };

  const pinBoxStyle = {width:56,height:64,background:'#EEEBE7',border:'1px solid #D4D1CE',borderRadius:4,display:'flex',alignItems:'center',justifyContent:'center',fontSize:28,fontWeight:700,color:'#111111'};

  return (
    <>
      <style>{CSS}</style>
      <div style={{minHeight:'100vh',background:'#F8F5F2',display:'flex',alignItems:'center',justifyContent:'center'}}>
        <div style={{width:360,padding:'48px 40px',background:'#FFFFFF',border:'1px solid #D4D1CE',borderRadius:4}}>
          <div style={{textAlign:'center',marginBottom:28}}>
            <img src={LOGO_B64} alt="Smart Tech" style={{height:48,maxWidth:240,objectFit:'contain',marginBottom:16,mixBlendMode:'multiply'}}/>
            <div style={{fontSize:11,color:'#777770',letterSpacing:'0.08em'}}>Enter your PIN to continue</div>
          </div>
          <div style={{display:'flex',justifyContent:'center',gap:12,marginBottom:24}}>
            {[0,1,2,3].map(i => (
              <div key={i} style={{...pinBoxStyle, borderColor: pin.length > i ? '#E50000' : '#D4D1CE'}}>
                {pin.length > i ? '●' : ''}
              </div>
            ))}
          </div>
          <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:8,marginBottom:16}}>
            {[1,2,3,4,5,6,7,8,9,'',0,'⌫'].map((n,i) => (
              <button key={i} onClick={() => {
                if(n==='⌫') setPin(p=>p.slice(0,-1));
                else if(n!=='') { const v=(pin+n).slice(0,4); setPin(v); if(v.length===4) handlePinCheck(v); }
              }} style={{padding:'14px',fontSize:18,fontWeight:500,background:n===''?'transparent':'#EEEBE7',border:'1px solid',borderColor:n===''?'transparent':'#D4D1CE',borderRadius:4,cursor:n===''?'default':'pointer',color:'#111111'}}>
                {n}
              </button>
            ))}
          </div>
          {pinError && <div style={{color:'#E50000',fontSize:12,marginBottom:12,textAlign:'center'}}>{pinError}</div>}
          <button onClick={() => { clearPin(); onSignOut(); }} style={{width:'100%',background:'transparent',border:'none',color:'#888880',fontSize:11,cursor:'pointer',textAlign:'center'}}>
            Sign out & use password
          </button>
        </div>
      </div>
    </>
  );
}

// PIN helpers
const PIN_KEY = 'st_installer_pin';
const hashPin = async (pin, email) => {
  const data = new TextEncoder().encode(pin + email + 'smarttech_salt_installer');
  const buf = await crypto.subtle.digest('SHA-256', data);
  return Array.from(new Uint8Array(buf)).map(b => b.toString(16).padStart(2,'0')).join('');
};
const savePin = async (pin, email) => {
  const hash = await hashPin(pin, email);
  localStorage.setItem(PIN_KEY, JSON.stringify({ hash, email }));
};
const getPin = () => { try { return JSON.parse(localStorage.getItem(PIN_KEY)); } catch { return null; } };
const clearPin = () => localStorage.removeItem(PIN_KEY);

function LoginScreen({ onLogin }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [mode, setMode] = useState(() => getPin() ? 'pin' : 'password');
  const [pin, setPin] = useState('');
  const [setupPin, setSetupPin] = useState(false);
  const [newPin, setNewPin] = useState('');
  const [confirmPin, setConfirmPin] = useState('');
  const [pinError, setPinError] = useState('');
  const savedPin = getPin();

  const handleLogin = async () => {
    setLoading(true);
    setError('');
    const { error, data } = await supabase.auth.signInWithPassword({ email, password });
    if (error) { setError('Invalid email or password'); setLoading(false); return; }
    setSetupPin(true);
    setLoading(false);
  };

  const handlePinLogin = async () => {
    if (pin.length !== 4) return;
    setLoading(true);
    setPinError('');
    const hash = await hashPin(pin, savedPin.email);
    if (hash === savedPin.hash) {
      onLogin();
    } else {
      setPinError('Incorrect PIN');
      setPin('');
    }
    setLoading(false);
  };

  const handleSavePin = async () => {
    if (newPin.length !== 4) { setPinError('PIN must be 4 digits'); return; }
    if (newPin !== confirmPin) { setPinError('PINs do not match'); return; }
    await savePin(newPin, email);
    setSetupPin(false);
    onLogin();
  };

  const inputStyle = {width:'100%',boxSizing:'border-box',background:'#EEEBE7',border:'1px solid #D4D1CE',borderRadius:3,padding:'10px 12px',color:'#111111',fontSize:13,outline:'none'};
  const btnStyle = {width:'100%',background:'#E50000',color:'#fff',border:'none',borderRadius:3,padding:'12px',fontSize:12,fontWeight:700,letterSpacing:'0.1em',textTransform:'uppercase',cursor:'pointer'};
  const pinBoxStyle = {width:56,height:64,background:'#EEEBE7',border:'1px solid #D4D1CE',borderRadius:4,display:'flex',alignItems:'center',justifyContent:'center',fontSize:28,fontWeight:700,color:'#111111'};

  if (setupPin) return (
    <>
      <style>{CSS}</style>
      <div style={{minHeight:'100vh',background:'#F8F5F2',display:'flex',alignItems:'center',justifyContent:'center'}}>
        <div style={{width:360,padding:'48px 40px',background:'#FFFFFF',border:'1px solid #D4D1CE',borderRadius:4}}>
          <div style={{textAlign:'center',marginBottom:28}}>
            <img src={LOGO_B64} alt="Smart Tech" style={{height:48,maxWidth:240,objectFit:'contain',marginBottom:16,mixBlendMode:'multiply'}}/>
            <div style={{fontSize:14,fontWeight:600,color:'#111111',marginBottom:6}}>Set Up a PIN</div>
            <div style={{fontSize:11,color:'#777770',lineHeight:1.6}}>Create a 4-digit PIN for faster sign-in next time.</div>
          </div>
          <div style={{marginBottom:16}}>
            <div style={{fontSize:10,letterSpacing:'0.1em',color:'#777770',textTransform:'uppercase',marginBottom:6}}>New PIN</div>
            <input type="password" inputMode="numeric" maxLength={4} value={newPin} onChange={e => setNewPin(e.target.value.replace(/\D/g,'').slice(0,4))}
              style={inputStyle} placeholder="••••"/>
          </div>
          <div style={{marginBottom:20}}>
            <div style={{fontSize:10,letterSpacing:'0.1em',color:'#777770',textTransform:'uppercase',marginBottom:6}}>Confirm PIN</div>
            <input type="password" inputMode="numeric" maxLength={4} value={confirmPin} onChange={e => setConfirmPin(e.target.value.replace(/\D/g,'').slice(0,4))}
              style={inputStyle} placeholder="••••"/>
          </div>
          {pinError && <div style={{color:'#E50000',fontSize:12,marginBottom:12,textAlign:'center'}}>{pinError}</div>}
          <button onClick={handleSavePin} style={{...btnStyle,marginBottom:10}}>Save PIN & Continue</button>
          <button onClick={() => { setSetupPin(false); onLogin(); }} style={{width:'100%',background:'transparent',border:'none',color:'#888880',fontSize:11,cursor:'pointer',textAlign:'center'}}>Skip for now</button>
        </div>
      </div>
    </>
  );

  return (
    <>
      <style>{CSS}</style>
      <div style={{minHeight:'100vh',background:'#F8F5F2',display:'flex',alignItems:'center',justifyContent:'center'}}>
        <div style={{width:360,padding:'48px 40px',background:'#FFFFFF',border:'1px solid #D4D1CE',borderRadius:4}}>
          <div style={{textAlign:'center',marginBottom:36}}>
            <img src={LOGO_B64} alt="Smart Tech" style={{height:48,maxWidth:240,objectFit:'contain',marginBottom:16,mixBlendMode:'multiply'}}/>
            <div style={{fontFamily:"'Montserrat',sans-serif",fontSize:10,letterSpacing:'0.28em',color:'#777770',textTransform:'uppercase',marginTop:4}}>Installer Dashboard</div>
          </div>

          {mode === 'pin' && savedPin ? (
            <>
              <div style={{fontSize:11,color:'#777770',textAlign:'center',marginBottom:20}}>Welcome back — enter your PIN</div>
              <div style={{display:'flex',justifyContent:'center',gap:12,marginBottom:24}}>
                {[0,1,2,3].map(i => (
                  <div key={i} style={{...pinBoxStyle, borderColor: pin.length > i ? '#E50000' : '#D4D1CE'}}>
                    {pin.length > i ? '●' : ''}
                  </div>
                ))}
              </div>
              <input type="password" inputMode="numeric" maxLength={4} value={pin}
                onChange={e => { const v = e.target.value.replace(/\D/g,'').slice(0,4); setPin(v); if(v.length===4) setTimeout(()=>handlePinLogin(),100); }}
                style={{position:'absolute',opacity:0,pointerEvents:'none'}} autoFocus/>
              <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:8,marginBottom:16}}>
                {[1,2,3,4,5,6,7,8,9,'',0,'⌫'].map((n,i) => (
                  <button key={i} onClick={() => {
                    if(n==='⌫') setPin(p=>p.slice(0,-1));
                    else if(n!=='') { const v=(pin+n).slice(0,4); setPin(v); if(v.length===4) setTimeout(()=>handlePinLogin(),100); }
                  }} style={{padding:'14px',fontSize:18,fontWeight:500,background: n===''?'transparent':'#EEEBE7',border:'1px solid',borderColor:n===''?'transparent':'#D4D1CE',borderRadius:4,cursor:n===''?'default':'pointer',color:'#111111'}}>
                    {n}
                  </button>
                ))}
              </div>
              {pinError && <div style={{color:'#E50000',fontSize:12,marginBottom:12,textAlign:'center'}}>{pinError}</div>}
              <button onClick={() => { setMode('password'); setPin(''); setPinError(''); }} style={{width:'100%',background:'transparent',border:'none',color:'#888880',fontSize:11,cursor:'pointer',textAlign:'center'}}>
                Use password instead
              </button>
            </>
          ) : (
            <>
              <div style={{marginBottom:16}}>
                <div style={{fontSize:10,letterSpacing:'0.1em',color:'#777770',textTransform:'uppercase',marginBottom:6}}>Email</div>
                <input type="email" value={email} onChange={e => setEmail(e.target.value)} onKeyDown={e => e.key === 'Enter' && handleLogin()}
                  style={inputStyle}/>
              </div>
              <div style={{marginBottom:24}}>
                <div style={{fontSize:10,letterSpacing:'0.1em',color:'#777770',textTransform:'uppercase',marginBottom:6}}>Password</div>
                <input type="password" value={password} onChange={e => setPassword(e.target.value)} onKeyDown={e => e.key === 'Enter' && handleLogin()}
                  style={inputStyle}/>
              </div>
              {error && <div style={{color:'#E50000',fontSize:12,marginBottom:16,textAlign:'center'}}>{error}</div>}
              <button onClick={handleLogin} disabled={loading} style={btnStyle}>
                {loading ? 'Signing in...' : 'Sign In'}
              </button>
              {savedPin && (
                <button onClick={() => { setMode('pin'); setError(''); }} style={{width:'100%',background:'transparent',border:'none',color:'#888880',fontSize:11,cursor:'pointer',textAlign:'center',marginTop:10}}>
                  Use PIN instead
                </button>
              )}
            </>
          )}
        </div>
      </div>
    </>
  );
}

export default function InstallerDashboard() {
  const [session, setSession] = useState(null);
  const [authChecked, setAuthChecked] = useState(false);
  const [pinUnlocked, setPinUnlocked] = useState(false);
  const [clients, setClients] = useState([]);
  const [loadingClients, setLoadingClients] = useState(true);
  const [selectedClient, setSelectedClient] = useState(null);
  const [globalRequest, setGlobalRequest] = useState(null);
  const [showLibrary, setShowLibrary] = useState(false);
  const [showRequests, setShowRequests] = useState(false);
  const [showCreds, setShowCreds] = useState(false);
  const [showNewClient, setShowNewClient] = useState(false);
  const [showInstallers, setShowInstallers] = useState(false);
  const [toast, setToast] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 1024);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
      setAuthChecked(true);
    });
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
    });

    // Re-lock PIN when app is backgrounded and comes back
    const handleVisibility = () => {
      if (document.visibilityState === 'hidden') {
        if (getPin()) setPinUnlocked(false);
      }
    };
    document.addEventListener('visibilitychange', handleVisibility);

    return () => {
      subscription.unsubscribe();
      document.removeEventListener('visibilitychange', handleVisibility);
    };
  }, []);

  // Load clients from Supabase
  useEffect(() => {
    if (!session) return;
    const loadClients = async () => {
      setLoadingClients(true);
      const { data, error } = await supabase
        .from('clients')
        .select('*, credentials:credentials(*), service_requests:service_requests(*)')
        .order('created_at', { ascending: false });
      if (!error && data) {
        // Map DB fields to app format
        const mapped = data.map(c => ({
          id: c.id,
          name: c.name,
          address: c.address || '',
          phone: c.phone || '',
          email: c.email || '',
          installDate: c.install_date || '',
          inviteStatus: c.invite_status || 'not-sent',
          systems: c.systems || [],
          credentials: (c.credentials || []).reduce((acc, cred) => ({ ...acc, [cred.system]: { username: cred.username || "", password: cred.password || "", email: cred.email || "" } }), {}),
          serviceRequests: (c.service_requests || []).map(r => ({
            id: r.id,
            subject: r.subject,
            message: r.message,
            priority: r.priority || 'normal',
            resolved: r.resolved || false,
            date: new Date(r.created_at).toLocaleDateString(),
            internalNote: r.internal_note || "",
            thread: r.thread || [],
            resolvedAt: r.resolved_at || null,
            lastReadInstaller: r.last_read_installer || null,
            lastReadClient: r.last_read_client || null,
          })),
        }));
        setClients(mapped);
      }
      setLoadingClients(false);
    };
    loadClients();
  }, [session]);

  if (!authChecked) return null;
  if (!session) return <LoginScreen onLogin={() => setPinUnlocked(true)} />;
  if (!pinUnlocked && getPin()) return <PinUnlockScreen onUnlock={() => setPinUnlocked(true)} onSignOut={() => supabase.auth.signOut()} />;
  // Role check - only admins and installers can access this
  const role = session.user?.user_metadata?.role;
  if (role && role !== 'installer' && role !== 'admin') {
    return (
      <>
        <style>{CSS}</style>
        <div style={{minHeight:'100vh',background:'#F8F5F2',display:'flex',alignItems:'center',justifyContent:'center',flexDirection:'column',gap:16}}>
          <div style={{color:'#E50000',fontSize:16,fontWeight:600}}>Access Denied</div>
          <div style={{color:'#777770',fontSize:13}}>This area is for installers only.</div>
          <button onClick={() => supabase.auth.signOut()} style={{marginTop:8,background:'#EEEBE7',border:'1px solid #D4D1CE',color:'#555550',padding:'8px 20px',borderRadius:3,cursor:'pointer',fontSize:12}}>Sign Out</button>
        </div>
      </>
    );
  }

  // Navigate from dashboard panel to client + open request
  const handleSelectRequest = (req) => {
    const client = clients.find(c => c.serviceRequests.some(r => r.id === req.id));
    if (client) {
      setSelectedClient(client);
      setGlobalRequest(req);
    }
  };

  const showToast = (msg) => {
    setToast(msg);
    setTimeout(() => setToast(null), 2500);
  };

  const handleCopy = (link) => {
    navigator.clipboard?.writeText(link).catch(() => {});
    showToast("Portal link copied to clipboard");
  };

  const handleNewClient = async (client) => {
    const { data, error } = await supabase.from('clients').insert([{
      name: client.name,
      address: client.address,
      phone: client.phone,
      email: client.email,
      install_date: client.installDate,
      system_name: client.systemName || "",
      invite_status: 'not-sent',
      systems: client.systems || [],
    }]).select().single();
    if (!error && data) {
      const newClient = {
        id: data.id,
        name: data.name,
        address: data.address || '',
        phone: data.phone || '',
        email: data.email || '',
        installDate: data.install_date || '',
        inviteStatus: data.invite_status || 'not-sent',
        systems: client.systems || [],
        credentials: {},
        serviceRequests: [],
      };
      setClients(p => [newClient, ...p]);
      showToast("Client created successfully");
    } else {
      showToast("Error creating client");
    }
    setShowNewClient(false);
  };

  const handleSendInvite = async (client) => {
    if (!client.email) {
      showToast("Client has no email address");
      return;
    }
    showToast("Sending invite...");
    try {
      const response = await fetch(
        `${process.env.REACT_APP_SUPABASE_URL}/auth/v1/invite`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'apikey': process.env.REACT_APP_SUPABASE_SERVICE_KEY,
            'Authorization': `Bearer ${process.env.REACT_APP_SUPABASE_SERVICE_KEY}`,
          },
          body: JSON.stringify({
            email: client.email,
            data: { role: 'client', client_id: client.id }
          })
        }
      );
      const data = await response.json();
      if (!response.ok || data.error) {
        showToast("Error: " + (data.error || data.msg || "Unknown error"));
      } else {
        handleUpdate({ ...client, inviteStatus: 'sent' });
        showToast("Invite sent to " + client.email);
      }
    } catch (err) {
      showToast("Network error: " + err.message);
    }
  };

  const handleDelete = async (client) => {
    await supabase.from('credentials').delete().eq('client_id', client.id);
    await supabase.from('service_requests').delete().eq('client_id', client.id);
    await supabase.from('clients').delete().eq('id', client.id);
    // Also delete from Supabase Auth if they have an account
    if (client.email) {
      try {
        // Find and delete the auth user by email
        const res = await fetch(
          `${process.env.REACT_APP_SUPABASE_URL}/auth/v1/admin/users`,
          {
            headers: {
              'apikey': process.env.REACT_APP_SUPABASE_SERVICE_KEY,
              'Authorization': `Bearer ${process.env.REACT_APP_SUPABASE_SERVICE_KEY}`,
            }
          }
        );
        const { users } = await res.json();
        const user = users?.find(u => u.email === client.email);
        if (user) {
          await fetch(
            `${process.env.REACT_APP_SUPABASE_URL}/auth/v1/admin/users/${user.id}`,
            {
              method: 'DELETE',
              headers: {
                'apikey': process.env.REACT_APP_SUPABASE_SERVICE_KEY,
                'Authorization': `Bearer ${process.env.REACT_APP_SUPABASE_SERVICE_KEY}`,
              }
            }
          );
        }
      } catch(e) {}
    }
    setClients(p => p.filter(c => c.id !== client.id));
    setSelectedClient(null);
    showToast("Client deleted");
  };

  const handleUpdate = async (updated) => {
    await supabase.from('clients').update({
      name: updated.name,
      address: updated.address,
      phone: updated.phone,
      email: updated.email,
      install_date: updated.installDate,
      invite_status: updated.inviteStatus,
      systems: updated.systems || [],
      system_name: updated.systemName || "",
    }).eq('id', updated.id);
    setClients(p => p.map(c => c.id === updated.id ? updated : c));
    setSelectedClient(updated);
  };

  const activeClient = selectedClient ? clients.find(c => c.id === selectedClient.id) : null;
  const isInstaller = session?.user?.user_metadata?.role === 'installer'; // false for admins → full access

  return (
    <>
      <style>{CSS}</style>
      <div className="id-root">
        {/* Nav */}
        <nav className="id-nav">
          <div className="id-nav-logo" style={{cursor:"pointer"}} onClick={() => setSelectedClient(null)}>
            <img src={LOGO_B64} alt="Smart Tech" style={{height:36, maxWidth:200, objectFit:'contain', mixBlendMode:'multiply'}}/>
          </div>
          <div className="id-nav-badge">{isInstaller ? 'Installer' : 'Admin'}</div>
          <button onClick={() => supabase.auth.signOut()} style={{marginLeft:'auto',background:'transparent',border:'1px solid #D4D1CE',color:'#888880',borderRadius:2,padding:'4px 12px',fontSize:9,fontWeight:700,letterSpacing:'0.08em',textTransform:'uppercase',cursor:'pointer'}}>Sign Out</button>
        </nav>

        <div className="id-body">
          {/* Sidebar */}
          <aside className="id-sidebar">
            <button className={`id-sidebar-item ${!selectedClient && !showLibrary && !showRequests ? "active" : ""}`} onClick={() => { setSelectedClient(null); setShowLibrary(false); setShowRequests(false); setShowCreds(false); }}>
              <Icon path={icons.clients} size={15}/> Clients
              <span className="id-sidebar-badge">{clients.length}</span>
            </button>
            <button className={`id-sidebar-item ${showRequests ? "active" : ""}`} onClick={() => { setSelectedClient(null); setShowLibrary(false); setShowRequests(true); setShowCreds(false); }}>
              <Icon path={icons.requests} size={15}/> Service Requests
              {clients.flatMap(c => c.serviceRequests).filter(r => !r.resolved).length > 0 && (
                <span className="id-sidebar-badge">{clients.flatMap(c => c.serviceRequests).filter(r => !r.resolved).length}</span>
              )}
            </button>
            <button className={`id-sidebar-item ${showCreds ? "active" : ""}`} onClick={() => { setSelectedClient(null); setShowLibrary(false); setShowRequests(false); setShowCreds(true); }}>
              <Icon path={icons.key} size={15}/> Credentials
            </button>
            <button className={`id-sidebar-item ${showLibrary ? "active" : ""}`} onClick={() => { setSelectedClient(null); setShowLibrary(true); setShowRequests(false); setShowCreds(false); setShowInstallers(false); }}>
              <Icon path={icons.devices} size={15}/> Equipment Library
            </button>
            {!isInstaller && (
              <button className={`id-sidebar-item ${showInstallers ? "active" : ""}`} onClick={() => { setSelectedClient(null); setShowLibrary(false); setShowRequests(false); setShowCreds(false); setShowInstallers(true); }}>
                <Icon path={icons.key} size={15}/> Manage Installers
              </button>
            )}















          </aside>

          {/* Main */}
          <main className="id-main">
            {showInstallers && !isInstaller ? (
              <ManageInstallersView onToast={showToast}/>
            ) : showCreds ? (
              <CredentialsView clients={clients} onSelectClient={(client) => { setSelectedClient(client); setShowCreds(false); }} isInstaller={isInstaller}/>
            ) : showRequests ? (
              <ServiceRequestsView clients={clients} onSelectClient={(client, req) => { setSelectedClient(client); setGlobalRequest(req); setShowRequests(false); }}/>
            ) : showLibrary ? (
              <LibraryView onClose={() => setShowLibrary(false)} onToast={showToast}/>
            ) : activeClient ? (
              <ClientDetail
                client={activeClient}
                onBack={() => { setSelectedClient(null); setGlobalRequest(null); }}
                onUpdate={handleUpdate}
                onCopy={handleCopy}
                onSendInvite={handleSendInvite}
                onDelete={handleDelete}
                onToast={showToast}
                initialRequest={globalRequest}
                onClearInitialRequest={() => setGlobalRequest(null)}
                isInstaller={isInstaller}
              />
            ) : (
              loadingClients ? (
                <div style={{display:'flex',alignItems:'center',justifyContent:'center',height:200,color:'#888880',fontSize:12,letterSpacing:'0.1em'}}>Loading clients...</div>
              ) : (
                <DashboardView
                  clients={clients}
                  onSelectClient={setSelectedClient}
                  onNewClient={() => setShowNewClient(true)}
                  onSelectRequest={handleSelectRequest}
                  isInstaller={isInstaller}
                />
              )
            )}
          </main>
        </div>

        {/* Mobile Bottom Tab Bar - JS rendered */}
        {isMobile && (
        <nav style={{
          position:'fixed', bottom:0, left:0, right:0, height:64,
          background:'#F8F5F2', borderTop:'1px solid #DDD9D4',
          zIndex:9999, display:'flex', alignItems:'stretch'
        }}>
          <button
            onClick={() => { setSelectedClient(null); setShowLibrary(false); setShowRequests(false); setShowCreds(false); }}
            style={{flex:1,display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',gap:4,background:'none',border:'none',cursor:'pointer',color:!selectedClient&&!showLibrary&&!showRequests&&!showCreds?'#E50000':'#888880',fontSize:8,fontWeight:700,letterSpacing:'0.08em',textTransform:'uppercase',padding:'8px 4px',position:'relative'}}>
            <Icon path={icons.clients} size={20}/>
            Clients
            {clients.length > 0 && <span style={{position:'absolute',top:8,right:'calc(50% - 14px)',background:'#E50000',color:'#fff',fontSize:8,fontWeight:700,minWidth:14,height:14,borderRadius:7,display:'flex',alignItems:'center',justifyContent:'center',padding:'0 3px'}}>{clients.length}</span>}
          </button>
          <button
            onClick={() => { setSelectedClient(null); setShowLibrary(false); setShowRequests(true); setShowCreds(false); }}
            style={{flex:1,display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',gap:4,background:'none',border:'none',cursor:'pointer',color:showRequests?'#E50000':'#888880',fontSize:8,fontWeight:700,letterSpacing:'0.08em',textTransform:'uppercase',padding:'8px 4px',position:'relative'}}>
            <Icon path={icons.requests} size={20}/>
            Requests
            {clients.flatMap(c => c.serviceRequests||[]).filter(r=>!r.resolved).length > 0 && (
              <span style={{position:'absolute',top:8,right:'calc(50% - 14px)',background:'#E50000',color:'#fff',fontSize:8,fontWeight:700,minWidth:14,height:14,borderRadius:7,display:'flex',alignItems:'center',justifyContent:'center',padding:'0 3px'}}>{clients.flatMap(c=>c.serviceRequests||[]).filter(r=>!r.resolved).length}</span>
            )}
          </button>
          <button
            onClick={() => { setSelectedClient(null); setShowLibrary(false); setShowRequests(false); setShowCreds(true); }}
            style={{flex:1,display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',gap:4,background:'none',border:'none',cursor:'pointer',color:showCreds?'#E50000':'#888880',fontSize:8,fontWeight:700,letterSpacing:'0.08em',textTransform:'uppercase',padding:'8px 4px'}}>
            <Icon path={icons.key} size={20}/>
            Passwords
          </button>
          <button
            onClick={() => { setSelectedClient(null); setShowLibrary(true); setShowRequests(false); setShowCreds(false); setShowInstallers(false); }}
            style={{flex:1,display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',gap:4,background:'none',border:'none',cursor:'pointer',color:showLibrary?'#E50000':'#888880',fontSize:8,fontWeight:700,letterSpacing:'0.08em',textTransform:'uppercase',padding:'8px 4px'}}>
            <Icon path={icons.devices} size={20}/>
            Equipment
          </button>
          {!isInstaller && (
          <button
            onClick={() => { setSelectedClient(null); setShowLibrary(false); setShowRequests(false); setShowCreds(false); setShowInstallers(true); }}
            style={{flex:1,display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',gap:4,background:'none',border:'none',cursor:'pointer',color:showInstallers?'#E50000':'#888880',fontSize:8,fontWeight:700,letterSpacing:'0.08em',textTransform:'uppercase',padding:'8px 4px'}}>
            <Icon path={icons.key} size={20}/>
            Installers
          </button>
          )}
        </nav>
        )}

        {showNewClient && (
          <NewClientModal onClose={() => setShowNewClient(false)} onSave={handleNewClient}/>
        )}

        {toast && (
          <div className="id-toast">
            <Icon path={icons.check} size={13} stroke="#22c55e" strokeWidth={2.5}/>
            {toast}
          </div>
        )}
      </div>
    </>
  );
}
